export const locale = {
  general_menu_settings: 'Allgemeine Menüeinstellungen',
  settings: {
  business_type_title: 'Wählen Sie die Art des Menügeschäfts',
  currency_label: 'Währung',
  show_filter: 'Produktfilter anzeigen',
  show_categories: 'Produktkategorien anzeigen',
  
  business_types: {
    cafe: 'Café',
    restaurant: 'Restaurant',
    fastfood: 'Fast Food',
    icecream: 'Saft & Eiscreme',
    sweets: 'Süßigkeiten & Desserts',
    bakery: 'Bäckerei'
  },
  
  custom_labels: {
    ph_menu_cafe: 'Café-Menü',
    ph_menu_restaurant: 'Speisekarte',
    ph_menu_fastfood: 'Fast-Food-Menü',
    ph_menu_icecream: 'Saft & Eis',
    ph_menu_sweets: 'Kuchen & Süßigkeiten',
    ph_menu_bakery: 'Brot & Backwaren',
    ph_product_list: 'Produkte',
    ph_add_order: 'Hinzufügen',
    ph_add_cart: 'Kaufen',
    title: 'Beschriftungen anpassen (Optional)',
    subtitle: 'Ersetzen Sie die Standardbegriffe des Systems durch Ihre bevorzugten Wörter.',
    products_title: 'Titel des Produktabschnitts',
    ph_food_menu: 'z.B. Speisekarte',
    ph_product_list: 'z.B. Produktliste',
    cart_btn: 'Text für die Checkout-Schaltfläche',
    ph_add_order: 'z.B. Zur Bestellung hinzufügen',
    ph_add_cart: 'z.B. Zum Warenkorb hinzufügen'
  },

  currencies: {
    toman: 'Toman',
    rial: 'Rial'
  }
},
check_account_balance_and_try_again: 'Bitte überprüfen Sie Ihr Kontoguthaben und versuchen Sie es erneut',
problem_with_qr_renewal_request: 'Beim Antrag zur Verlängerung des QR-Codes ist ein Problem aufgetreten',

  ERRORS: {
    PhoneIsNotValid:
      "Die eingegebene Telefonnummer ist ungültig: z.B. 09101234567",
    InvalidNumber: "Die eingegebene Anzahl ist ungültig.",
    NoSelectedLineNumber: "Bitte wählen Sie eine Absenderleitung.",
    EmptyText: "Bitte geben Sie einen Text ein.",
    UnknownError: "Unbekannter Fehler",
    TryAgain: "Bitte versuchen Sie es später noch einmal.",
    NoAccountCharge: "Unzureichendes Guthaben",
    NoAccess: "Zugriff verweigert.",
    PleasebyeAPlane: "Bitte kaufen Sie einen Plan.",
    PleaseChargeYourAccount: "Bitte laden Sie Ihr Konto auf.",
    AccessDenied: "Zugriff verweigert.",
    AccessDeniedDescription:
      "Kontaktieren Sie den Support für weitere Informationen.",
    Error: "Fehler",
    InvalidText: "Ungültiger Text",
    InvalidTextContainsLink: "Nur Service-Leitungen dürfen Links enthalten.",
    NoPhoneToSend: "Es gibt keine Nummern zum Senden.",
  },
  FORMS: {
    SuccsessFullySended: "Verstanden",
    DestinationPhone: "Empfängernummer",
    TestDestinationPhone: "Test-Telefonnummer",
    SourceNumber: "Absendernummer",
    Text: "Text",
    CharCount: "Zeichenanzahl",
    FarsiCharCount: "Anzahl persischer Zeichen",
    EnglishCharCount: "Anzahl englischer Zeichen",
    Send: "Senden",
    SendTime: "Sendezeit",
    SendTest: "Test senden",
    SendToTestNumber: "An Testnummer senden",
    SmsCount: "SMS-Anzahl",
    SmsLang: "SMS-Sprache",
    Add: "Hinzufügen",
    FromFile: "Aus Datei hinzufügen",
    TestNumber: "Testnummer",
    Test: "Test",
    ServiceRelated: "Service/Transaktional",
    Price: "Kosten für Whitelist",
    TotalPrice: "Gesamtkosten",
    NumbersCount: "Gesamtzahl der Nummern",
    BlacklistPrice: "Kosten für Blacklist",
    BlacklistNumbersCount: "Blacklist-Anzahl",
    WhitelistNumbersCount: "Whitelist-Anzahl",
    IrancellNumbersBlacklistCount: "Irancell Blacklist-Anzahl",
    HamrahavalNumbersBlacklistCount: "Hamrah Aval Blacklist-Anzahl",
    IrancellNumbersWhitelistCount: "Irancell Whitelist-Anzahl",
    HamrahavalNumbersWhitelistCount: "Hamrah Aval Whitelist-Anzahl",
    NumbersCountToSend: "Anzahl gültiger Nummern",
    Search: "Suchen",
    Title: "Titel",
    RequestTime: "Anfragezeit",
    RequestInformation: "Anfrageinformationen",
    CreateNewPhoneBook: "Neues Telefonbuch erstellen",
    AddPhone: "Nummern hinzufügen",
    Remove: "Entfernen",
  },
  unexpected_error:
    "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
  luck_wheel_name: "Name des Glücksrads‑QR",
  update_video: "Videogalerie hinzufügen",
  edit: "Bearbeiten",
  to_top: "Von oben",
  to_bottom: "Von unten",
  to_left: "Von rechts nach links",
  to_right: "Von links nach rechts",
  to_top_right: "Von unten nach rechts",
  to_top_left: "Von unten nach links",
  to_bottom_right: "Von oben nach rechts",
  to_bottom_left: "Von oben nach links",
  select_color_gradient: "Verlauf wählen",
  select_color_solid: "Einfarbig wählen",
  gradient_direction: "Verlaufsrichtung",
  gradient_background: "Verlaufshintergrund",
  qr_downloaded_successfully: "QR erfolgreich heruntergeladen.",
  logo: "Logo",
  qr_design_size: "QR-Design und Größe",
  qr_eye_design: "Augen-Design des QR",
  qr_markout: "Ausgabe-Rand",
  frame: "Rahmen",
  ready_card_samples: "Fertige Visitenkarten-Beispiele",
  ready_card_sample: "Fertiges Visitenkarten-Beispiel",
  remove_default_info: "Standardinformationen entfernen",
  select_ready_card: "Fertige Karte auswählen",
  connection_code: "Verbindungscode",
  enter_visit_card_info: "Visitenkarteninformationen eingeben",
  info: "Informationen",
  select_template_design: "Vorlagendesign auswählen",
  qr_address: "QR-Adresse",
  visit_card_name: "Name Ihrer Visitenkarte",
  visit_card_name_pro: "Name Ihrer Visitenkarte Pro",

  download_qr: "QR herunterladen",
  fast_design: "Schnelles Design",
  professional_design: "Professionelles Design",
  ai_design: "KI-Design",
  update_qr: "QR aktualisieren",
  fast_design_message:
    "Sie sind zum Schnellcode-Design gewechselt. Das vorherige Design wurde in diesem Abschnitt erstellt.",
  professional_design_message:
    "Sie sind zum professionellen Code-Design gewechselt. Das vorherige Design wurde in diesem Abschnitt erstellt.",
  scan_me: "Scanne mich",
  visit_card_edited_successfully:
    "Ihre Visitenkarte wurde erfolgreich bearbeitet.",
  customer_club_membership: "Mitgliedschaft im Kundenclub",
  qrland: "QR Land",
  dynamic: "Dynamisch",
  about_us_text:
    "Merkmale des dynamischen QR-Codes:\n✔️ Unbegrenzte Bearbeitung\n✔️ Einfaches Scannen\n✔️ Scanbegrenzung möglich\n✔️ Passwort hinzufügen\n✔️ Besucherstatistiken anzeigen\n✔️ Farbe und Aussehen ändern\n✔️ Daten- und Sicherheitsschutz\n✔️ Foto und Logo hinzufügen\n✔️ Spezialisierter QR nach Bedarf\n✔️ Weiterleitung zu Links und Website\n✔️ QR + Kurzlink zusammen\n✔️ Auf allen Netzwerken nutzbar (offline/online)\n✔️ In jedem Format herunterladbar\n✔️ Auf jeder Oberfläche und Größe druckbar",
  video_gallery: "Videogalerie",
  address_text: "Berlin, Alexanderplatz 6, Gebäude 6",
  visit_card: "Visitenkarte",
  qrland_system: "QR Land System",
  qrland_first_system: "Erstes System zur Erstellung dynamischer QR-Codes",
  address: "Adresse",
  enter_site_link: "Gewünschten Website-Link eingeben",
  instagram: "Instagram",
  enter_instagram_username: "Geben Sie Ihren Benutzernamen ein",
  whatsapp: "WhatsApp",
  invalid_qr_address: "Die eingegebene Adresse ist ungültig!",
  visit_card_created_successfully:
    "Ihre Visitenkarte wurde erfolgreich erstellt.",
  qr_creation_failed: "QR-Erstellung fehlgeschlagen!",
  manage_password: "Passwort verwalten",
  hour_limit: "Stundenlimit",
  scan_click_limit: "Scan-/Klicklimit",
  redirect_scanner: "Scanner umleiten",
  edit_settings_error: "Fehler beim Bearbeiten der Einstellungen!",
  next: "Weiter",
  add: "Hinzufügen",
  header_color_settings: "Kopfzeilen-Farb- und Text-Einstellungen",
  select_image: "Bild auswählen",
  enter_qr_address: "Geben Sie Ihre QR-Adresse ein",
  qr_idea_title: "QR-Erstellungsidee",
  qr_idea: "QR-Idee",
  qr_idea_subject: "QR-Erstellungsthema",
  confirm_qr_idea: "Meine QR-Idee bestätigen",
  scannable: "Scannbar",
  ai_sample: "Beispiel von KI generiert...",
  scan_warning:
    "Kann auf allen Geräten nicht gescannt werden. Bei Fehlschlag erneut versuchen.",
  ai_description:
    "Beschreiben Sie den gewünschten QR, die KI erstellt ihn für Sie.",
  attach: "Anhängen",
  remaining: "Verbleibend",
  qr_creation: "QR-Erstellung",
  free: "Kostenlos",
  select_language_for_request: "Sprache für Anfragetext auswählen",
  request_text: "Anfragetext",
  request_text_placeholder: "Beschreiben Sie den gewünschten QR-Link...",
  strengthen_text: "Vorhandenen Text verstärken",
  prompt_idea: "Prompt-Idee",
  try_again: "Erneut versuchen",
  create_qr: "QR erstellen",
  smart_qr_code: "Intelligenter QR-Code",
  regenerate_image: "Bild neu generieren",
  updating_qr: "QR wird aktualisiert...",
  copied: "Kopiert",
  copy: "Kopieren",
  print_qr: "QR drucken",
  print_visit_card: "Visitenkarte drucken",
  send_link: "Link senden",
  customer_list: "Kundenliste",
  order_list: "Bestellliste",
  reserved_appointments: "Reservierte Termine",
  feedback: "Feedback",
  request_form: "Anfrageformular",
  transfer_ownership: "Eigentum übertragen",
  select_nfc_card: "NFC-Karte auswählen",
  created_at: "Erstellt am",
  last_edit: "Zuletzt bearbeitet",
  qr_card: "QR-Karte",
  viewed: "Angesehen",
  see_more: "Mehr anzeigen",
  download: "Herunterladen",
  activate: "Aktivieren",
  design: "Design",
  qr_settings: "QR-Einstellungen",
  deactivate: "Deaktivieren",
  qr_color_size: "QR-Farbe und Größe",
  dots_design_color: "Punkt-Design und Farbe",
  eye_design_color: "Augen-Design und Farbe",
  border_design_color: "Rahmen-Design und Farbe",
  logo_settings: "Logo-Einstellungen",
  download_qr_comment: "QR herunterladen",
  connection_established: "Verbindung hergestellt.",
  show_qr: "QR anzeigen",
  preview: "Vorschau",
  user_info: "Benutzerinformationen",
  sms_club_membership: "SMS-Club-Mitgliedschaft",
  smart_settings: "Intelligente Einstellungen",
  add_audio_file: "Audiodatei hinzufügen",
  back: "Zurück",
  after_click_location: "Nach Klick auf Standort Ihre Karten-App auswählen.",
  phone_number: "Telefonnummer",
  auto_display: "Automatische Anzeige",
  customer_club: "Kundenclub",
  auto_download: "Automatischer Download",
  save: "Speichern",
  about_us: "Über uns",
  view_more: "Mehr anzeigen",
  view_less: "Weniger anzeigen",
  audio_file: "Audiodatei",
  add_video: "Video hinzufügen",
  add_image: "Bild hinzufügen",
  select_color: "Farbe wählen",
  header_color: "Kopfzeilentext",
  add_social_networks: "Soziale Netzwerke hinzufügen",
  format: "Format",
  output_size: "Ausgabegröße",
  file_type: "Dateityp",
  default: "Standard",
  qr_download_error: "Fehler beim Herunterladen des QR. Erneut versuchen",
  header_color_text_settings: "Kopfzeilen-Farb- und Text-Einstellungen",
  upload_catalog_images: "Katalog-/Broschürenbilder hochladen",
  delete: "Löschen",
  personal_domain: "Persönliche Domain",
  no_domain_found: "Keine Domain gefunden!",
  enter_domain_address: "Bitte geben Sie Ihre Domain-Adresse ein",
  dns_setup_note: "Denken Sie daran, zuerst die Server-DNS einzustellen!",
  attention: "Achtung: ",
  dns_setup_instruction:
    "Um eine persönliche Domain zu registrieren, richten Sie zuerst die DNS ein",
  and: "und",
  setup_on_domain: "auf Ihrer Domain ein.",
  dns_change_time: "(DNS-Änderung kann bis zu 24 Stunden dauern)",
  add_domain: "Domain hinzufügen",
  add_personal_domain: "Persönliche Domain hinzufügen",
  min_characters: "Mindestanzahl an Eingabezeichen",
  domain_format:
    "Die Website-Domain muss im Format https://terminalads.com oder terminalads.com eingegeben werden.",
  invalid_domain: "Die eingegebene Domain ist ungültig!",
  domain_added_successfully: "Ihre Domain wurde erfolgreich hinzugefügt",
  invalid_dns_settings: "DNS-Einstellungen sind ungültig!",
  deleted_successfully: "Erfolgreich gelöscht",
  location: "Standort",
  save_contact: "Kontakt speichern",
  search: "Suchen",
  data_fetch_error: "Fehler beim Abrufen der Daten!",
  error: "Fehler",
  view_qr: "QR anzeigen",
  qr_design: "QR-Design",
  register: "Registrieren",
  terminal_ads: "Terminal Werbung",
  manage_40_advertising_methods: "40 Werbemethoden gleichzeitig verwalten!",
  ms_khansari: "Frau Khansari",
  support: "Support",
  comprehensive_advertising_system:
    "Das einzige umfassende System zur Analyse und Verwaltung von Online-Werbung",
  terminal_ads_description:
    "Das Terminal Werbung System ist stolz darauf, durch kontinuierliche und effektive Kommunikation mit Kunden und Nutzern deren Bedürfnisse zu verstehen und die besten Lösungen anzubieten. Unser größtes Kapital sind unsere treuen Kunden und Nutzer, gefolgt von unserem Expertenteam, das das Unternehmen mit neuen Ideen und modernen Technologien unterstützt.",
  please_enter_qr_address_correctly:
    "Bitte geben Sie die QR-Adresse korrekt ein!",
  server_error: "Serverfehler!",
  please_enter_your_address: "Bitte geben Sie Ihre Adresse ein",
  please_enter_instagram_address: "Bitte geben Sie Ihre Instagram-Adresse ein",
  please_enter_whatsapp_address: "Bitte geben Sie Ihre WhatsApp-Adresse ein",
  enter_information: "Informationen eingeben",
  dynamic_qr: "Dynamischer QR",
  coming_soon: "Demnächst",
  qr_name: "QR-Name",
  for_default_address_leave_empty: "!Für Standardadresse leer lassen",
  default_address: "Standardadresse",
  sms: "SMS",
  enter_number_without_zero: "Nummer ohne 0 eingeben.",
  number: "Nummer",
  country_code: "Ländercode:",
  sms_text: "SMS-Text",
  complete_sms_fields_correctly: "Bitte füllen Sie die SMS-Felder korrekt aus!",
  qr_code_created_successfully: "Ihr QR-Code wurde erfolgreich erstellt.",
  chat: "Chat",
  call: "Anruf",
  please_enter_username: "Bitte geben Sie Ihren Benutzernamen ein.",
  username: "Benutzername",
  sample_menu: "Beispielmenü",
  online_menu_name: "Name Ihres Online-Menüs",
  online_menu_name_short: "Online-Menü-Name",
  enter_menu_information: "Geben Sie Menüinformationen ein",
  select_sample_menu: "Wählen Sie ein Beispielmenü",
  select_ready_menu: "Wählen Sie ein fertiges Menü",
  online_sales: "Online-Verkauf",
  sales_settings: "Verkaufseinstellungen",
  photo_gallery: "Fotogalerie",
  fast_food1: "Fast Food 1",
  fast_food2: "Fast Food 2",
  products: "Produkte",
  pizzas: "Pizzen",
  pizza_rust_beef: "Pizza Roastbeef",
  italian_pizza_with_beef: "🤩 Italienische Pizza mit Rindfleisch",
  italian_pizza_dough_30cm: "Italienischer Pizzateig 30 cm",
  "100g_shredded_beef": "100 g gehacktes Rindfleisch",
  mushroom_bell_pepper: "Pilze, Paprika",
  black_olives: "Schwarze Oliven",
  pizza_chicken_mushroom: "Pizza Hähnchen & Pilze",
  classic_40cm: "🍕 Klassik 40 cm",
  fresh_tomato_sauce:
    "Frische Tomatensauce, Käse, Hähnchenfilet, Pilze, Bergthymian",
  pizza_meat_mushroom: "Pizza Fleisch & Pilze",
  meat_pizza_with_mushroom: "🥰 Pizza mit Hackfleisch und Pilzen",
  pizza_vegetables: "Gemüsepizza",
  american_vegetable_pizza: "🍕 Amerikanische Gemüsepizza",
  american_pizza_dough:
    "Amerikanischer Pizzateig, Mais, Pilze, Oliven, Tomaten, Zwiebeln, Paprika, Käse",
  special_pizza: "Spezialpizza",
  american_special_pizza: "Amerikanische Spezialpizza",
  pizza_bolognese: "Pizza Bolognese",
  one_person_23cm: "(1 Person) Pizzateig 23 cm 🤌",
  pepperoni_pizza: "Pepperoni-Pizza",
  one_person_23cm_dough: "(1 Person) Pizzateig 23 cm",
  bacon_pizza: "Bacon-Pizza",
  one_person_23cm_explosion: "(1 Person) Pizzateig 23 cm 💥",
  mixed_pizza: "Gemischte Pizza",
  one_person_23cm_mixed: "(1 Person) Pizzateig 23 cm 🤭",
  american_steak_pizza: "Amerikanische Steak-Pizza",
  one_person_23cm_steak: "(1 Person) 23 cm 💥",
  burgers: "Burger",
  cheese_burger: "Cheeseburger",
  with_french_fries: "🤩 mit Pommes frites",
  "2_beef_burgers_150g": "2 Rindfleischburger à 150 g",
  special_sauce_gouda_cheese: "Spezialsauce, Gouda-Käse",
  pickles_lettuce_tomato: "Gurken, Salat, Tomate",
  special_sauce: "Spezialsauce",
  burger: "Burger",
  pure_meat_with_special_sauce: "😍 Reines Fleisch mit Spezialsauce",
  chicken_burger: "Hähnchenburger",
  grilled_chicken_burger_with_cheese: "Gegrillter Hähnchenburger mit Käse",
  spicy_burger: "Scharfer Burger",
  beef_with_spicy_sauce: "Rindfleisch mit scharfer Sauce",
  double_burger: "Doppelburger",
  "150g_beef": "Rindfleisch 150 g",
  royal_burger: "Royal Burger",
  "150g_beef_emoji": "150 g Rindfleisch 🍔",
  mushroom_burger: "Pilzburger",
  "150g_beef_mushroom": "Rindfleisch 150 g",
  mushroom_burger_grilled: "Champignon-Burger",
  "100_percent_grilled_beef": "100 % gegrilltes Rindfleisch 🤩",
  fried_burger: "Frittierter Burger",
  "100_percent_grilled_fried":
    "100 % gegrilltes und frittiertes Rindfleisch 👌",
  fried: "Frittiert",
  fried_chicken: "Frittiertes Hähnchen",
  "3_piece_fried_chicken": "😍 3 Stück frittiertes Hähnchen",
  "3_fried_chicken_pieces": "3 Stück frittiertes Hähnchen",
  "120_150g_french_fries": "120-150 g Pommes frites",
  enter_product_information: "Geben Sie Produktinformationen ein",
  product_name: "Ihr Produktname",
  product_name_short: "Produktname",
  complete_features_from_image: "Ergänzen Sie Merkmale aus dem Produktbild",
  skip_step: "Schritt überspringen",
  product_and_information: "Produkt und Informationen",
  product_introduction: "Produktvorstellung",
  shiva_waves: "Shiva Wellen",
  think_best: "Denken Sie am besten...",
  iran_zanjan_abhar:
    "Iran, Zanjan, Abhar, Sharif Industriegebiet, neben dem 63/20 kV-Umspannwerk",
  video_gallery_description: "Schauen Sie sich unsere Videos an.",
  gallery: "Galerie",
  welcome: "Willkommen",
  invalid_address: "Die eingegebene Adresse ist ungültig!",
  product_created_successfully: "Ihr Produkt wurde erfolgreich erstellt.",
  qr_visit_card_edited_successfully:
    "Ihre Visitenkarte wurde erfolgreich bearbeitet.",
  change_header_color: "Kopfzeilenfarbe ändern",
  change_body_color: "Textfarbe ändern",
  change_button_colors: "Schaltflächenfarben ändern",
  change_text_colors: "Textfarben ändern",
  gradient_colors: "Verlaufsfarben",
  color_direction: "Farbrichtung",
  first_color: "Erste Farbe",
  second_color: "Zweite Farbe",
  color: "Farbe",
  text_color: "Textfarbe",
  from_top: "Von oben",
  from_bottom: "Von unten",
  from_left_to_right: "Von links nach rechts",
  from_right_to_left: "Von rechts nach links",
  from_top_to_left: "Von oben links",
  from_top_to_right: "Von oben rechts",
  from_bottom_to_left: "Von unten links",
  from_bottom_to_right: "Von unten rechts",
  sharing: "Teilen",
  business_shop: "Geschäft / Laden",
  corporate_organizational: "Unternehmen / Organisation",
  customer_contact: "Kundenkontakt",
  information: "Informationen",
  miscellaneous: "Sonstiges",
  link: "Link",
  margin: "Rand",
  width: "Breite",
  height: "Höhe",
  background_color: "Hintergrundfarbe",
  gradient_color: "Verlaufsfarbe",
  linear: "Linear",
  radial: "Radial",
  color_rotation: "Farbdrehung",
  background_color_label: "Hintergrundfarbe",
  dots_color: "Punktefarbe",
  dots_color_label: "Punktefarbe",
  eye_colors: "Augenfarben",
  separate_colors_for_each_eye: "Separate Farben für jedes Auge",
  current_mode: "Aktueller Modus:",
  separate_colors: "Separate Farben",
  same_color: "Gleiche Farbe",
  all_eyes_color: "Farbe aller Augen",
  top_right_eye: "Oberes rechtes Auge",
  top_left_eye: "Oberes linkes Auge",
  bottom_left_eye: "Unteres linkes Auge",
  upload_logo: "Logo hochladen",
  hide_background_dots: "Punkte hinter dem Logo ausblenden",
  logo_size: "Logogröße",
  logo_margin: "Logorand",
  qr_accuracy: "QR-Genauigkeit",
  mode: "Modus",
  error_correction_level: "Fehlerkorrekturlevel",
  numeric: "Numerisch",
  alphanumeric: "Alphanumerisch",
  byte: "Byte",
  apply_changes: "Änderungen übernehmen",
  please_click_apply_changes:
    'Klicken Sie auf "Änderungen übernehmen", nachdem Sie die Anpassungen ausgewählt haben.',
  created_qr_codes: "Erstellte QR-Codes",
  square_ratio: "1:1 (quadratisch)",
  image_upload_error: "Fehler beim Hochladen des Bildes!",
  visit_card_name_label: "Name der Visitenkarte",
  sms_membership_message: "SMS-Mitgliedschaftsnachricht für Kundenclub",
  admin_menu: "Admin-Menü",
  user_menu: "Benutzermenü",
  guide_tooltip: "Anleitung",
  close: "Schließen",
  browser_video_support_error: "Ihr Browser unterstützt kein Videoformat.",
  video_loading_error:
    "Fehler beim Laden des Videos (möglicherweise eingeschränkter Zugriff).",
  click_more_for_videos: "Klicken Sie auf „Mehr“, um weitere Videos zu sehen.",
  more_info: "Weitere Informationen",
  more: "Mehr",
  add_user_guide: "Benutzeranleitung hinzufügen",
  edit_user_guide: "Benutzeranleitung bearbeiten",
  display_info: "Informationen anzeigen",
  element: "Element",
  disable_attach: "Anhängen deaktivieren, um zur Seite zu passen",
  view: "Ansehen",
  guide: "Anleitung",
  details: "Details",
  guide_images: "Anleitungsbilder",
  guide_videos: "Anleitungsvideos",
  faq: "Häufig gestellte Fragen",
  data_preload_error: "Fehler beim Vorladen der Daten:",
  guide_not_found: "Keine Anleitung gefunden. Erstellen Sie zuerst eine.",
  delete_guide_question: "Anleitung löschen?",
  delete_guide_error: "Fehler beim Löschen der Anleitung!",
  unknown_file_type: "Unbekannter Dateityp:",
  content_type_error: "Fehler beim Empfangen des Inhaltstyps:",
  video: "Video",
  image: "Bild",
  guide_data_error: "Fehler beim Empfangen der Anleitungsdaten:",
  add_iranian_stores: "Iranische Stores hinzufügen",
  add_foreign_stores: "Ausländische Stores hinzufügen",
  bazaar: "Bazaar",
  myket: "Myket",
  app_store: "App Store",
  google_play: "Google Play",
  samsung_store: "Samsung Store",
  xiaomi_store: "Xiaomi Store",
  vivo_store: "Vivo Store",
  amazon_store: "Amazon Store",
  bazaar_app: "Bazaar-App",
  bazaar_link_placeholder: "Geben Sie den App-Link für Bazaar ein",
  bazaar_link_hint:
    "Geben Sie einen gültigen Bazaar-Link ein (Beispiel: https://cafebazaar.ir/app/com.abankefarda)",
  myket_app: "Myket-App",
  myket_link_placeholder: "Geben Sie den App-Link für Myket ein",
  myket_link_hint:
    "Geben Sie einen gültigen Myket-Link ein (Beispiel: myket://details?id=com.example)",
  app_store_app: "App Store-App",
  app_store_link_placeholder: "Geben Sie den App-Link für den App Store ein",
  app_store_link_hint:
    "Geben Sie einen gültigen App Store-Link ein (Beispiel: https://apps.apple.com/us/app/appname/id123456789)",
  google_play_app: "Google Play-App",
  google_play_link_placeholder: "Geben Sie den App-Link für Google Play ein",
  google_play_link_hint:
    "Geben Sie einen gültigen Google Play-Link ein (Beispiel: https://play.google.com/store/apps/details?id=com.example)",
  samsung_store_app: "Samsung Store-App",
  samsung_store_link_placeholder:
    "Geben Sie den App-Link für den Samsung Store ein",
  samsung_store_link_hint:
    "Geben Sie einen gültigen Samsung Store-Link ein (Beispiel: https://galaxy.store/appname)",
  xiaomi_store_app: "Xiaomi Store-App",
  xiaomi_store_link_placeholder:
    "Geben Sie den App-Link für den Xiaomi Store ein",
  xiaomi_store_link_hint: "Geben Sie einen gültigen Xiaomi Store-Link ein",
  vivo_app_store: "Vivo App Store",
  vivo_app_store_app: "Vivo App Store-App",
  vivo_app_store_link_placeholder:
    "Geben Sie den App-Link für den Vivo App Store ein",
  vivo_app_store_link_hint: "Geben Sie einen gültigen Vivo App Store-Link ein",
  amazon_store_app: "Amazon Store-App",
  amazon_store_link_placeholder:
    "Geben Sie den App-Link für den Amazon Store ein",
  amazon_store_link_hint: "Geben Sie einen gültigen Amazon Store-Link ein",
  iranian_store: "Iranischer Store",
  foreign_store: "Ausländischer Store",
  personal_store: "Persönlicher Store",
  image_logo: "Bild/Logo",
  image_gallery: "Bildergalerie",
  header_image: "Kopfzeilenbild",
  template_background_image: "Vorlagenhintergrundbild",
  background_image: "Hintergrundbild",
  background_image_alt: "Hintergrundbild",
  logo_upload: "Logo hochladen",
  welcome_image: "Willkommensbild",
  welcome_image_logo_upload: "Willkommensbild/Logo hochladen",
  loading_animation: "Ladeanimation",
  preview_welcome_page: "Vorschau der Willkommensseite",
  max_background_size: "Maximale Größe pro Hintergrundbild: 2 MB.",
  max_logo_size: "Maximale Größe pro Logo: 2 MB.",
  scale_from_center: "Vom Zentrum skalieren",
  slide_from_left: "Von links einblenden",
  slide_from_top: "Von oben einblenden",
  fade: "Ausblenden",
  select_music_card: "Musikkarte auswählen",
  show_audio: "Audio anzeigen",
  hide_audio: "Audio ausblenden",
  add_voice: "Sprachnachricht hinzufügen",
  max_files_limit: "Sie können nicht mehr als {count} Dateien auswählen!",
  files_not_allowed: "Dateien nicht erlaubt!",
  voice_gallery: "Sprachgalerie",
  edit_voice: "Sprachnachricht bearbeiten",
  list: "Liste",
  file_name: "Dateiname",
  title: "Titel",
  description: "Beschreibung",
  selectdate: "Datum auswählen",
  background: "Hintergrund",
  text: "Text",
  delete_audio_confirm:
    "Sind Sie sicher, dass Sie die Audiodatei aus Ihrer Galerie löschen möchten?",
  add_voice_gallery: "Sprachgalerie hinzufügen",
  gallery_number: "Galerie",
  delete_confirm: "Sind Sie sicher, dass Sie löschen möchten?",
  confirm: "?",
  voice_gallery_title_hint: "Geben Sie den Titel Ihrer Sprachgalerie ein.",
  voice_gallery_title: "Titel",
  voice_gallery_subtitle_hint:
    "Geben Sie den Untertitel Ihrer Sprachgalerie ein.",
  voice_gallery_subtitle: "Untertitel der Sprachgalerie",
  voice_gallery_subtitle_alt: "Untertitel",
  website_address_hint: "Geben Sie Ihre Website-Adresse ein.",
  website_address: "Website-Adresse",
  about_voice_gallery: "Über die Galerie",
  about_voice_gallery_alt: "Über die Galerie",
  button_name_hint: "Geben Sie den Schaltflächennamen ein.",
  button_name: "Schaltflächenname",
  domain_format_hint:
    "Die Domain muss https://terminalads.com oder terminalads.com sein.",
  about_us_alt: "Über uns",
  add_default_form: "Standardformular hinzufügen",
  delete_all: "Alles löschen",
  validation_active: "Validierung: Aktiv",
  validation_inactive: "Validierung: Inaktiv",
  validation: "Validierung",
  clear_form: "Formular leeren",
  status: "Status",
  active: "Aktiv",
  inactive: "Inaktiv",
  optional: "Optional",
  required: "Erforderlich",
  question_title: "Titel",
  question_title_hint: "Geben Sie die Frage ein",
  options_hint:
    "Schreiben Sie die Optionen und drücken Sie Enter, um hinzuzufügen",
  options: "Optionen",
  add_suggested_form: "Vorgeschlagenes Formular hinzufügen",
  save_changes: "Änderungen speichern",
  add_request_field: "Anfragefeld hinzufügen",
  select_form_type: "Formulartyp auswählen",
  select_form_type_placeholder: "Formulartyp auswählen",
  dropdown: "Dropdown",
  text_field: "Textfeld",
  number_field: "Zahlenfeld",
  textarea_field: "Textbereich",
  date_field: "Datumsfeld",
  field_name_required: "Feldname darf nicht leer sein",
  field_name: "Feldname",
  add_field_name: "Feldname hinzufügen",
  field_label: "Feldbezeichnung",
  add_field_label: "Feldbezeichnung hinzufügen",
  advanced_settings: "Erweiterte Einstellungen",
  select_input_pattern: "Eingabemuster auswählen",
  select_input_pattern_placeholder: "Eingabemuster auswählen",
  max_characters: "Maximale Zeichenanzahl",
  min_input_error: "Mindesteingabe muss 0 sein",
  name_field: "Name",
  field_type: "Feldtyp",
  persian_limit: "Persische Sprachbeschränkung",
  family_name: "Nachname",
  mobile_number: "Mobilnummer",
  number_limit: "Zahlenbeschränkung",
  national_code: "Nationalcode",
  meli_code: "Nationalcode",
  email: "E-Mail",
  email_limit: "E-Mail-Beschränkung",
  dropdown_field: "Dropdown-Feld",
  english_limit: "Englische Sprachbeschränkung",
  mix_per_eng_limit: "Persisch-Englisch-Mischbeschränkung",
  site_limit: "Website-Beschränkung",
  form_added_successfully: "Das neue Formular wurde erfolgreich hinzugefügt",
  form_updated_successfully: "Das Formular wurde erfolgreich aktualisiert",
  delete_item_confirm: "Sind Sie sicher, dass Sie das Element löschen möchten?",
  default_form_added_successfully:
    "Das Standardformular wurde erfolgreich hinzugefügt",
  resources_upload_error: "Fehler beim Hochladen der Ressourcen",
  update_value_if_duplicate: "Wert aktualisieren, falls doppelt",
  first_tab: "Erster Tab",
  display_count: "Anzeigeanzahl",
  buy_renew_qr_instruction:
    "Um einen QR-Code zu kaufen/zu verlängern, klicken Sie auf die Ablauffrist-Schaltfläche.",
  days_until_expiry: "Tage bis Ablauf",
  expired: "Abgelaufen",
  no_qr_to_display: "Kein QR-Code zum Anzeigen!",
  second_tab: "Zweiter Tab",
  total_qr_codes: "Gesamte QR-Codes",
  select_all: "Alle auswählen",
  selected_qr_codes_count: "Anzahl ausgewählter QR-Codes",
  qr_codes_count: "Anzahl QR-Codes",
  group_renewal_instruction:
    "Für Gruppenverlängerung wählen Sie die gewünschten QR-Codes aus.",
  no_qr_found_with_filters: "Keine QR-Codes mit diesen Filtern gefunden!",
  qr_codes_count_label: "Anzahl QR-Codes:",
  renew_qr: "QR-Code verlängern",
  days: "Tage",
  buy_now: "Jetzt kaufen!",
  buy_now_label: "Kaufen",
  add_discount_code: "Rabattcode hinzufügen",
  use_discount_code: "Rabattcode verwenden",
  discount_code: "Rabattcode",
  submit: "Absenden",
  my_qr_list: "Meine QR-Liste",
  group_renewal: "Gruppenverlängerung",
  row: "Zeile",
  type: "Typ",
  clicks: "Klicks",
  created_at_diff: "Erstellungszeit",
  updated_at_diff: "Aktualisierungszeit",
  table_view: "Tabellenansicht",
  normal_view: "Normale Ansicht",
  no_qr_or_id_selected: "Kein QR-Code oder ID ausgewählt!",
  qr_updated_successfully: "QR-Code erfolgreich aktualisiert.",
  qr_update_error: "Fehler beim Aktualisieren des QR-Codes!",
  no_qr_selected: "Kein QR-Code ausgewählt!",
  no_qr_code_selected: "Kein QR-Code ausgewählt!",
  success: "Erfolg",
  qrs_upgraded_successfully: "Ihre QR-Codes wurden erfolgreich aktualisiert.",
  qr_renewal_error: "Problem bei der Verlängerungsanfrage des QR-Codes!",
  changed_successfully: "Erfolgreich geändert.",
  error_occurred: "Ein Fehler ist aufgetreten!",
  no_tariff_exists: "Kein Tarif vorhanden!",
  qr_upgraded_successfully: "Ihr QR-Code wurde erfolgreich aktualisiert.",
  check_account_balance:
    "Überprüfen Sie Ihr Kontostand und versuchen Sie es später erneut.",
  group_renewal_price_error:
    "Fehler beim Abrufen des Gruppenverlängerungspreises!",
  qr_count_error: "Fehler beim Abrufen der QR-Code-Anzahl!",
  no_qr_for_renewal: "Kein QR-Code zur Verlängerung!",
  table_pagination: "Tabellenpaginierung",
  virtual_scroll_display: "Virtuelle Scroll-Anzeige",
  popups_shared_components: "Pop-ups und gemeinsame Komponenten",
  edit_qr_address: "QR-Adresse bearbeiten",
  please_enter_correct_address: "Bitte geben Sie eine korrekte Adresse ein",
  successfully_edited: "Erfolgreich bearbeitet.",
  error_editing_qr_address: "Fehler beim Bearbeiten der QR-Adresse!",
  go_to_page: "Zur Seite gehen",
  page_from_to: "Seite {current} von {last}",
  display: "Anzeigen",
  to: "bis",
  from: "von",
  show: "Anzeigen",
  page_status: "Seite {current} von {total}",
  until: "bis",
  successfully_completed: "Erfolgreich abgeschlossen",
  problem_occurred: "Ein Problem ist aufgetreten",
  download_failed: "Download fehlgeschlagen",
  audio_file_default: "Audiodatei",
  memory_release: "Speicherfreigabe",
  seek_music_comment:
    "Zum Beispiel diese Musik oder alles, wonach gesucht wird",
  all: "Alle",
  create_podcast: "Podcast erstellen",
  add_link: "Link hinzufügen",
  upload_file: "Datei hochladen",
  file_list: "Dateiliste",
  count: "Anzahl",
  select_category: "Kategorie auswählen",
  after_typing_enter: "Nach dem Tippen Enter drücken.",
  no_image_available: "Kein Bild verfügbar",
  no_image_found: "Kein Bild gefunden!",
  for_adding_file_use_upload_center:
    "Um eine Datei hinzuzufügen, verwenden Sie das Upload-Feld oder das Upload-Center",
  ai_story_creation_description:
    "Geben Sie Ihre Geschichte ein, und die KI erstellt sie für Sie",
  create_new_podcast: "Neuen Podcast erstellen",
  show_audio_file: "Audiodatei anzeigen",
  cancel: "Abbrechen",
  no_audio_in_category: "Keine Audiodateien in dieser Kategorie",
  health_apple: "Gesundheitsapfel",
  standard: "Standard",
  arshia_badge: "Arshia-Abzeichen",
  home_appliances_association: "Verein für Haushaltsgeräte",
  energy_label: "Energielabel",
  select_gold_purity_first:
    "Um den Preis zu erhalten, wählen Sie zuerst die Goldreinheit",
  gold_price_service: "Goldpreis-Dienst",
  rahvard: "Rahvard",
  to_change_gold_service_go_to_assets:
    "Um den Goldpreis-Dienst zu ändern, gehen Sie zum Bereich Vermögenswerte",
  gold: "Gold",
  purity: "Reinheit",
  rial: "Rial",
  final_product_price: "Endproduktpreis",
  show_images_right_side: "Bilder rechts anzeigen",
  show_as_slider: "Als Slider anzeigen.",
  show_as_grid: "Als Gitter anzeigen.",
  show_as_second_mode: "Im zweiten Modus anzeigen.",
  gallery_name: "Galeriename",
  change_gallery_name: "Galeriename ändern",
  add_photo: "Foto hinzufügen",
  select_photo: "Foto auswählen",
  show_image: "Bild anzeigen",
  selected_photo: "Ausgewähltes Foto",
  to_use_ready_images_search_category_or_product:
    "Um fertige Bilder zu verwenden, suchen Sie oben nach Kategorie oder Produkt.",
  max_file_size_2mb: "Maximale Dateigröße: 2 MB.",
  drag_and_drop_to_upload_or: "Ziehen und ablegen zum Hochladen oder",
  here: "hier",
  click: "klicken",
  to_use_external_image_link_fill_fields:
    "Um einen externen Bildlink zu verwenden, füllen Sie die Felder unten aus",
  image_url_hint: "Die gewünschte Bild-URL (Link).",
  image_url: "Bildlink",
  add_new_gallery: "Neue Galerie hinzufügen",
  create_image: "Bild erstellen",
  ready_images: "Fertige Bilder",
  edit_image: "Bild bearbeiten",
  enter_valid_link: "Geben Sie einen gültigen Link ein.",
  max_background_image_size_2mb: "Maximale Größe pro Hintergrundbild: 2 MB.",
  uploaded_successfully: "Erfolgreich hochgeladen.",
  banner: "Banner",
  question: "Frage",
  selected_question: "Ausgewählte Frage",
  answer: "Antwort",
  add_question: "Frage hinzufügen",
  selected_blog: "Ausgewählter Blog",
  icon: "Icon",
  select_icon: "Icon auswählen",
  add_blog: "Blog hinzufügen",
  post: "Beitrag",
  selected_services: "Ausgewählte Dienste",
  add_new_post: "Neuen Beitrag hinzufügen",
  add_new_services: "Neue Dienste hinzufügen",
  add_new_service: "Neuen Dienst hinzufügen",
  domain_must_be_https_or_http:
    "Die Domain muss https://terminalads.com oder terminalads.com sein.",
  id: "ID",
  images: "Bilder",
  tags: "Tags",
  print_type: "Drucktyp",
  user: "Benutzer",
  user_shipping_info: "Versandinformationen des Benutzers",
  qr_short_link: "Kurzlink für QR",
  delivery_method: "Liefermethode",
  delivery_at_company: "Lieferung im Unternehmen",
  delivery_by_post: "Versand per Post",
  post_cost_and_tax_warning:
    "Bei Registrierung werden Versandkosten und 10 % Steuer von Ihrem Guthaben abgezogen.",
  shipping_info: "Versandinformationen",
  continue_shopping: "Einkauf fortsetzen",
  complete_shopping: "Finaliser l'achat",
  select_free_nfc_card: "Kostenlose NFC-Karte auswählen",
  order_custom_nfc_card: "Benutzerdefinierte NFC-Karte bestellen",
  buy_qr_equipment: "QR-Ausrüstung kaufen",
  vertical: "Vertikal",
  horizontal: "Horizontal",
  card_type: "Kartentyp",
  tag: "Tag",
  select: "Auswählen",
  order_card: "Karte bestellen",
  available: "Verfügbar",
  unavailable: "Nicht verfügbar",
  for_initial_loading: "Für das erste Laden",
  already_have_free_nfc_message:
    "Sie haben bereits eine kostenlose NFC für diesen QR-Code erhalten. Um zu ändern, kaufen Sie eine benutzerdefinierte Karte.",
  nfc_in_delivery_process_message:
    "Sie haben bereits eine kostenlose NFC registriert, die unterwegs ist. Um zu ändern, kaufen Sie eine benutzerdefinierte.",
  free_nfc_card_warning_message:
    "Lieber Kunde: Kostenlose NFC-Karten sind vorbedruckt, Ihr QR-Code ändert sich. Wenn Sie ihn verwenden, kaufen Sie eine benutzerdefinierte.",
  select_card: "Karte auswählen",
  free_card_selection_conditions:
    "Bedingungen für die Auswahl der kostenlosen Karte",
  confirm_and_select: "Bestätigen und auswählen",
  registered_successfully: "Erfolgreich registriert.",
  error_registering_nfc_order:
    "Fehler bei der Registrierung der NFC-Kartenbestellung!",
  nfc_physical_card_orders: "Bestellungen physischer NFC-Karten",
  buy_equipment: "Ausrüstung kaufen",
  select_quantity: "Menge auswählen",
  ready_samples: "Fertige Muster",
  upload_custom_design: "Benutzerdefiniertes Design hochladen",
  select_ready_card_image: "Fertiges Kartenbild auswählen",
  select_card_front_image: "Karten-Vorderseite auswählen",
  select_card_back_image: "Karten-Rückseite auswählen",
  nfc_card_image: "NFC-Kartenbild",
  add_quantity: "Menge hinzufügen",
  total_price: "Gesamtpreis",
  price_with_discount: "Preis mit Rabatt",
  shipping_cost: "Versandkosten",
  your_profit_from_purchase: "Ihr Gewinn aus dem Kauf",
  discount: "Rabatt",
  ten_percent_tax_will_be_added:
    "10 % Steuer werden zum Endbetrag hinzugefügt.",
  payable_amount: "Zu zahlender Betrag",
  continue: "Fortfahren",
  Confirm_code: "Code bestätigen",
  form_success_message: "Ihr Formular wurde erfolgreich gesendet",
  refill_form_message: "Füllen Sie das Formular erneut aus",
  Enter_the_sent_code: "Geben Sie den gesendeten Code ein",
  SUBMIT_FORM: "Formular absenden",
  enter_phone_number: "Geben Sie Ihre Mobilnummer ein",
  order_registered_successfully:
    "Ihre Bestellung wurde erfolgreich registriert.",
  smart_creation: "Intelligente Erstellung",
  automatic_creation: "Automatische Erstellung",
  business_name: "Geschäftsname",
  example_household_goods: "Beispiel: Haushaltswaren",
  organization_name: "Organisationsname",
  example_tech_company: "Beispiel: Fortgeschrittenes Technologieunternehmen",
  minimum_two_characters_required: "Mindestens zwei Zeichen erforderlich!",
  maximum_100_characters_allowed: "Maximal 100 Zeichen erlaubt",
  latin_name_qr_address: "Lateinischer Name (QR-Adresse)",
  example_advanced_tech: "Beispiel: advanced-tech",
  only_english_numbers_dash_allowed:
    "Nur englische Buchstaben, Zahlen und Bindestriche erlaubt",
  maximum_50_characters_allowed: "Maximal 50 Zeichen erlaubt",
  latin_name_goes_after_domain: "Der lateinische Name kommt nach der Domain",
  select_logo_and_store_product_image: "Wählen Sie Logo und Laden-/Produktbild",
  select_logo: "Logo auswählen",
  file_size_must_be_less_than_2mb: "Dateigröße muss unter 2 MB liegen",
  for_buying_renewing_qr_click_expiry_button:
    "Um einen QR-Code zu kaufen/zu verlängern, klicken Sie auf die Ablauffrist-Schaltfläche.",
  for_group_renewal_select_desired_qr_codes:
    "Für Gruppenverlängerung wählen Sie die gewünschten QR-Codes aus.",
  no_qr_found_with_these_filters: "Keine QR-Codes mit diesen Filtern gefunden!",
  i_buy: "Ich kaufe",
  visits: "Besuche",
  creation_time: "Erstellungszeit",
  edit_time: "Bearbeitungszeit",
  enter_business_card_name_correctly:
    "Geben Sie den Namen der Visitenkarte korrekt ein!",
  are_you_sure_delete_qr:
    "Sind Sie sicher, dass Sie den QR-Code löschen möchten?",
  qr_deleted_successfully: "QR-Code erfolgreich gelöscht.",
  are_you_sure_deactivate_qr:
    "Sind Sie sicher, dass Sie den QR-Code deaktivieren möchten?",
  are_you_sure_activate_qr:
    "Sind Sie sicher, dass Sie den QR-Code aktivieren möchten?",
  deactivated: "Deaktiviert",
  qr_successfully: "QR-Code erfolgreich",
  successfully: "Erfolgreich",
  user_transferred_successfully: "Benutzer erfolgreich übertragen",
  problem_occurred_in_transfer: "Problem bei der Übertragung!",
  error_in_user_transfer: "Fehler bei der Benutzerübertragung!",
  qr_business_card_edited_successfully:
    "Ihre Visitenkarte wurde erfolgreich bearbeitet.",
  group_qr_renewal: "Gruppenverlängerung von QR-Codes",
  select_desired_duration: "Wählen Sie die gewünschte Dauer",
  total_count: "Gesamtanzahl",
  final_amount: "Endbetrag",
  ten_percent_vat_will_be_added:
    "10 % Mehrwertsteuer werden zum obigen Betrag hinzugefügt.",
  pay_and_upgrade: "Bezahlen und upgraden",
  no_tariff_for_this_period: "Kein Tarif für diesen Zeitraum!",
  selected: "Ausgewählt",
  total_amount: "Gesamtbetrag",
  final_amount_with_discount: "Endbetrag mit Rabatt",
  add_qr: "QR hinzufügen",
  actions: "Aktionen",
  filter_type: "Typfilter",
  start_from: "Beginnen ab",
  search_in_id: "In ID suchen",
  filter_user: "Benutzer filtern",
  clear_filters: "Filter zurücksetzen",
  send_sms: "SMS senden",
  selected_pattern: "Ausgewähltes Muster",
  send: "Senden",
  bulk_download: "Massen-Download",
  one_month_renewal: "Monatliche Verlängerung",
  three_month_renewal: "Dreimonatige Verlängerung",
  six_month_renewal: "Sechsmonatige Verlängerung",
  one_year_renewal: "Jährliche Verlängerung",
  no_item_selected: "Kein Element ausgewählt!",
  error_loading_card_info: "Fehler beim Laden der Karteninformationen!",
  send_registered_successfully: "Senden erfolgreich registriert",
  error_getting_prices: "Fehler beim Abrufen der Preise!",
  payment_error: "Zahlungsfehler!",
  business_card: "Visitenkarte",
  product_label: "Produktetikett",
  restaurant_menu: "Restaurantmenü",
  event_ticket: "Veranstaltungsticket",
  brochure: "Broschüre",
  flyer: "Flyer",
  poster: "Poster",
  catalog: "Katalog",
  newsletter: "Newsletter",
  organization_name_hint: "Geben Sie Ihren Organisationsnamen ein.",
  organization_name_label: "Organisationsname",
  sub_organization_hint: "Geben Sie den Unterorganisationsnamen ein.",
  sub_organization_label: "Beschreibung des Unterorganisationsnamens",
  user_name_hint: "Geben Sie Ihren Namen ein.",
  user_name_label: "Name und Nachname",
  work_field_hint: "Geben Sie Ihre Position ein.",
  work_field_label: "Position",
  mobile_number_hint: "Geben Sie Ihre Nummer ein.",
  mobile_number_label: "Mobilnummer",
  phone_number_hint: "Geben Sie die Telefonnummer ein.",
  phone_number_label: "Telefonnummer",
  email_hint: "Geben Sie Ihre E-Mail ein.",
  email_label: "E-Mail",
  fax_hint: "Geben Sie das Unternehmensfax ein.",
  fax_label: "Unternehmensfax",
  website_hint: "Geben Sie die Unternehmenswebsite ein.",
  website_label: "Unternehmenswebsite",
  postal_code_hint: "Geben Sie die Postleitzahl ein.",
  postal_code_label: "Postleitzahl",
  copyright_hint: "Geben Sie den Urheberrechtstext in der Fußzeile ein.",
  copyright_label: "Urheberrechtstext",
  address_hint: "Geben Sie Ihre Adresse ein.",
  address_label: "Adresse",
  add_more_info: "Fügen Sie weitere gewünschte Informationen hinzu:",
  edit_location: "Bearbeiten",
  add_location: "Hinzufügen",
  delete_location: "Ort löschen",
  about_us_label: "Über uns",
  search_address: "Nach Adresse suchen:",
  northern_coordinates: "Nördliche Koordinaten",
  eastern_coordinates: "Östliche Koordinaten",
  select_address_on_map: "Adresse auf der Karte auswählen",
  location_not_found: "Ort nicht gefunden.",
  text_label: "Text",
  number_label: "Nummer",
  website_address_label: "Website-Adresse",
  location_label: "Ort",
  mobile_viewer_title: "Mobile Viewer",
  visit_theme_two_title: "Visitenkarten-Theme 2",
  visit_theme_flipped_title: "Umgedrehtes Visitenkarten-Theme",
  flip_card: "Karte umdrehen",
  flip_card_description:
    "Um mehr Informationen zu sehen, drehen Sie die Karte um",
  share_contacts: "Kontakte teilen",
  close_share: "Teilen schließen",
  card_front: "Karten-Vorderseite",
  card_back: "Karten-Rückseite",
  flip_to_back: "Zur Rückseite drehen",
  flip_to_front: "Zur Vorderseite drehen",
  swipe_to_flip: "Wischen zum Umdrehen",
  swipe_left: "Nach links wischen",
  swipe_right: "Nach rechts wischen",
  expand_card: "Karte erweitern",
  contract_card: "Karte verkleinern",
  view_details: "Details anzeigen",
  hide_details: "Details ausblenden",
  social_media_share: "Teilen in sozialen Medien",
  contact_actions: "Kontaktaktionen",
  card_actions: "Kartenaktionen",
  floating_menu: "Schwebendes Menü",
  close_menu: "Menü schließen",
  open_menu: "Menü öffnen",
  choice_gallery: "Ausgewählte Galerie",
  choice_video: "Video auswählen",
  url_video: "Video-Link",
  selected_video: "Ausgewähltes Video",
  add_video: "Video hinzufügen",
  edit_video: "Video bearbeiten",
  linl_video: "Übertragungslink",
  upload_video: "Video hochladen",
  rule_link:
    "Die Domain muss https://terminalads.com oder terminalads.com sein.",
  fax_hint: "Geben Sie das Unternehmensfax ein.",
  fax_label: "Unternehmensfax",
  website_hint: "Geben Sie die Unternehmenswebsite ein.",
  website_label: "Unternehmenswebsite",
  postal_code_hint: "Geben Sie die Postleitzahl ein.",
  postal_code_label: "Postleitzahl",
  add_more_info: "Fügen Sie weitere gewünschte Informationen hinzu:",
  address_hint: "Geben Sie Ihre Adresse ein.",
  address_label: "Adresse",
  edit_location: "Bearbeiten",
  add_location: "Hinzufügen",
  delete_location: "Ort löschen",
  location_label: "Ort",
  about_company_label: "Über das Unternehmen",
  select_address_on_map: "Adresse auf der Karte auswählen",
  search_address: "Nach Adresse suchen:",
  rule_link:
    "Die Domain muss https://terminalads.com oder terminalads.com sein.",
  link_label: "Link-Adresse",
  label_label: "Bezeichnung",
  field_value_label: "Feldwert",
  add_new_field: "Neues Feld hinzufügen",
  tehran_address:
    "Teheran, Shariati-Straße, nach der Seyed Khandan-Brücke, Khandan-Gasse, Nr. 6",
  welcome_message_hint:
    "Wenn aktiviert, erhält der Kunde beim Beitritt zu Ihrem Club eine Willkommensnachricht.",
  change_pattern_campaign: "Muster/Kampagne ändern",
  selected_message: "Ausgewählte Nachricht:",
  required_inputs: "Erforderliche Eingaben:",
  selected_campaign_or_pattern: "Ausgewählte Kampagne/Muster:",
  campaign: "Kampagne",
  pattern: "Muster",
  id: "ID",
  auto_csv_download_label: "Automatisches Speichern",
  auto_csv_download_hint:
    "Nach dem Öffnen der Karte werden Ihre Informationen automatisch auf das Handy des Kunden heruntergeladen.",
  show_cclub_onload_label: "Mitgliedschaftsvorschlag",
  show_cclub_onload_hint:
    "Ein Fenster öffnet sich zum Beitritt zum Kundenclub.",
  forced_submission_hint:
    "Beim Anzeigen des Mitgliedschaftsformulars muss der Kunde seine Nummer registrieren.",
  forced_submission_forced: "Pflichtmitgliedschaft",
  forced_submission_optional: "Optionale Mitgliedschaft",
  has_manifest_icons_label: "Web-App-Anpassung",
  has_assistant_label: "Assistenten-Label",
  select_assistant: "Assistent auswählen",
  assistant_ai: "KI-Assistent",
  has_manifest_icons_hint:
    "Das Logo und das Bild erscheinen, wenn die Web-App auf Handy oder Computer installiert wird.",
  logo_144px: "Logo 144 px",
  logo_48px: "Logo 48 px",
  photo_wide: "Breites Foto",
  photo: "Foto",
  iranian_social_networks: "Iranische soziale Netzwerke",
  foreign_social_networks: "Ausländische soziale Netzwerke",
  advertising_sites: "Werbeseiten",
  other_links: "Andere Links",
  custom_text: "Benutzerdefinierter Text",
  custom_text_placeholder: "Geben Sie Ihren benutzerdefinierten Text ein.",
  aparat: "Aparat",
  aparat_hint: "Geben Sie Ihren Kanalnamen bei Aparat ein",
  eitaa: "Eitaa",
  eitaa_hint: "Geben Sie Ihren Benutzernamen ein",
  soroush: "Soroush",
  soroush_hint: "Geben Sie Ihren Benutzernamen ein",
  bale: "Bale",
  bale_hint: "Geben Sie Ihren Benutzernamen ein",
  rubika: "Rubika",
  rubika_hint: "Geben Sie den Kanal-/Gruppenlink ein",
  gap: "Gap",
  gap_hint: "Geben Sie Ihren Benutzernamen ein",
  linkedin: "Persönliches LinkedIn-Profil",
  linkedin_hint: "Geben Sie Ihren Benutzernamen ein",
  linkedin_company: "LinkedIn-Unternehmensseite",
  linkedin_company_hint: "Geben Sie den Namen Ihrer Unternehmensseite ein",
  pinterest: "Pinterest",
  pinterest_hint: "Geben Sie Ihren Benutzernamen ein",
  dribbble: "Dribbble",
  dribbble_hint: "Geben Sie Ihren Benutzernamen ein",
  facebook: "Facebook",
  facebook_hint: "Geben Sie Ihren Benutzernamen ein",
  github: "GitHub",
  github_hint: "Geben Sie Ihren Benutzernamen ein",
  threads: "Threads",
  threads_hint: "Geben Sie Ihren Benutzernamen ein",
  tiktok: "TikTok",
  tiktok_hint: "Geben Sie Ihren Benutzernamen ein",
  twitter: "Twitter",
  twitter_hint: "Geben Sie Ihren Benutzernamen ein",
  skype: "Skype",
  skype_hint: "Geben Sie Ihren Benutzernamen ein",
  youtube: "YouTube",
  youtube_hint: "Geben Sie Ihren Benutzernamen ohne @ ein",
  wechat: "WeChat",
  wechat_hint: "Geben Sie Ihren Benutzernamen ein",
  viber: "Viber",
  viber_hint: "Geben Sie Ihren Benutzernamen ein",
  divar: "Divar",
  divar_hint: "Geben Sie den Anzeigen-/Board-/Shop-Link ein",
  sheypoor: "Sheypoor",
  sheypoor_hint: "Geben Sie den Anzeigen-/Board-/Shop-Link ein",
  social_network: "Soziales Netzwerk",
  photo_logo_tab: "Bild/Logo",
  gallery_image_tab: "Bildergalerie",
  template_image: "Vorlagenbild",
  background_image: "Hintergrundbild",
  upload_logo: "Logo hochladen",
  welcome_image_upload: "Willkommensbild/Logo hochladen",
  welcome_photo: "Willkommensfoto",
  loading_animation: "Ladeanimation",
  preview_welcome_page: "Vorschau der Willkommensseite",
  default_template_image: "Standard-Vorlagenhintergrundbild",
  default_background_image: "Standard-Hintergrundbild",
  default_logo: "Standard-Logo",
  default_welcome: "Standard-Willkommen",
  default_gallery: "Standard-Galerie",
  animation_scale: "Vom Zentrum skalieren",
  animation_slide_x: "Von links einblenden",
  animation_slide_y: "Von oben einblenden",
  animation_fade: "Ausblenden",
  image_size_error: "Maximale Größe pro Hintergrundbild: 2 MB.",
  logo_size_error: "Maximale Größe pro Logo: 2 MB.",
  categories: {
    bankcard: 'Bankkarte',
    bale: "Bale",
    robika: "Robika",
    eitaa: "Eitaa",
    text: "Text",
    multi_card: "Multi-Karte",
    product_introduction_pro: "Produktvorstellung Pro",
    "gift": "Geschenk",
    electronic_business_card_pro: "Elektronische Visitenkarte Pro",
    link_pro:"Link Pro",
    generated_images: "Generierte Bilder",
    electronic_business_card: "Elektronische Visitenkarte",
    social_media: "Soziale Medien",
    photo_gallery: "Fotogalerie",
    video_gallery: "Videogalerie",
    link: "Link",
    audio_gallery: "Audiogalerie",
    audio_gallery_pro: "Audiogalerie (Pro)",
    feedback: "Feedback",
    consultation_form: "Beratungsformular",
    application: "Bewerbung",
    pdf_gallery: "PDF-Galerie",
    schedule_table: "Zeitplantabelle",
    personal_company_website: "Persönliche/Unternehmenswebsite",
    online_store: "Online-Shop",
    online_menu: "Online-Menü",
    appointment_booking: "Terminbuchung",
    commercial_admin_website: "Gewerbe-/Verwaltungswebsite",
    online_insurance_sales: "Online-Versicherungsverkauf",
    discount_code: "Rabattcode",
    product_introduction: "Produktvorstellung",
    product_label: "Produktetikett",
    gold_label: "Goldetikett",
    franchise: "Franchise (Geschäftsseite)",
    marketplace: "Marktplatz (Geschäftsseite)",
    recruitment_form: "Einstellungsformular",
    organizational_form: "Organisationsformular",
    employee_card: "Mitarbeiterkarte",
    book_magazine: "Buch/Zeitschrift",
    catalog_brochure: "Katalog/Broschüre",
    catalog: "Katalog",
    faq: "FAQ",
    feedback_survey: "Feedback/Umfrage",
    consultation_request: "Beratungsanfrage",
    customer_club: "Kundenclub",
    invitation_card: "Einladungskarte",
    countdown: "Countdown",
    tombstone: "Grabstein",
  },
  support_day60: "60 Tage Geld-zurück-Garantie",
  "enter_visit_card_pro_info": "Geben Sie den Namen der Pro-Visitenkarte ein",

  ROUTE: {
    TITLES: {
      QR_NAME_EDIT_TEXT: "QR-Text bearbeiten",
       SERVER_DOWN: "Wird aktualisiert",
    CREATE_MEMORIES_MODEL: "Erinnerungsrahmen-Vorlage erstellen",
    CREATE_CARD_VISIT_PRO_MODEL: "Visitenkarten-Pro-Vorlage erstellen",
    CREATE_PRODUCT_PRO_MODEL: "Produktvorstellung-Pro-Vorlage erstellen",
    CREATE_PRODUCT_LABEL_MODEL: "Produktetikett-Vorlage erstellen",
    CREATE_PHOTO_GALLERY_MODEL: "Fotogalerie-Vorlage erstellen",
    CREATE_PDF_GALLERY_MODEL: "PDF-Galerie-Vorlage erstellen",
    CREATE_SOCIAL_MEDIA_MODEL: "Social-Media-Vorlage erstellen",
    EDIT_CARD_VISIT_PRO_MODEL: "Visitenkarten-Pro-Vorlage bearbeiten",
    EDIT_PRODUCT_PRO_MODEL: "Produktvorstellung-Pro-Vorlage bearbeiten",
    EDIT_PRODUCT_LABEL_MODEL: "Produktetikett-Vorlage bearbeiten",
    EDIT_PHOTO_GALLERY_MODEL: "Fotogalerie-Vorlage bearbeiten",
    EDIT_PDF_GALLERY_MODEL: "PDF-Galerie-Vorlage bearbeiten",
    EDIT_SOCIAL_MEDIA_MODEL: "Social-Media-Vorlage bearbeiten",
    BOOK: "Buch",
    NFC_LIST: "NFC-Liste",
    API_KEY_MANAGER: "API-Schlüssel erstellen",
    PRE_PURCHASE: "Vorbestellung",
    PRE_PURCHASE_MODEL: "Fertige Vorlage",
    "QR_NAME_EDIT_GIFT": "Geschenk-QR-Code bearbeiten",
     "QR_GIFT": "Geschenk-QR-Code",
      "QR_NAME_EDIT_PRO": "Pro-Link QR-Code bearbeiten",
      "QR_LINK_PRO": "QR Link Pro",
      DIGI: "Digikala Preisüberwachung",
      QR_PDF: "PDF‑Galerie",
      QR_NAME_EDIT_PDF: "PDF‑Galerie bearbeiten",
      QR_MULTICART: "QR‑Multi‑Karte",
      QR_MULTICART_EDIT: "QR‑Multi‑Karte bearbeiten",
      QR_PRODUCTPRO: "Produkt Pro Vorstellung",
      QR_NAME_PRODUCTPRO: "Produkt Pro Vorstellung bearbeiten",
      QR_NAME_EDIT_CATALOG: "Katalog bearbeiten",
      QR_LUCK_WHEEL_Edit: "Glücksrad bearbeiten",
      QR_LUCK_WHEEL: "QR-Code für Glücksrad erstellen",
      DASHBOARD: "Dashboard",
      ADMIN_QR_DOMAINS: "Domain-Überwachung",
      ADMIN_TOGETHER_TOKEN: "Token-Überwachung",
      ADMIN_QR_SMS: "SMS-Versand",
      MENU_PROFILE_INFO: "Benutzerinformationen",
      MENU_PROFILE_SETTING: "Profileinstellungen",
      MENU_PROFILE_ORDERS: "Bestellungen",
      MENU_PROFILE_ADDRESSES: "Adressen",
      QR_MONITORING: "QR-Überwachung",
      QR_LIST: "Meine QR-Liste",
      QR_NAME_LIST: "Teilnahmemanagement",
      QR_GENERATE_MULTIPLE: "Massen-QR-Code-Erstellung",
      QR_CARD_VISIT: "Visitenkarte erstellen",
      HELP_INFO: "Button testen",
      QR_MENU: "Shop-Menü",
      QR_APPOINTMENT: "Terminbuchung",
      QR_INSURANCE: "Online-Versicherung erstellen",
      QR_BPAGE: "Arbeitsseite erstellen",
      QR_CPAGE: "Website für Gewerbe-/Verwaltungskomplex erstellen",
      QR_BSHOP: "Online-Shop",
      QR_NAME_EDIT_BSHOP: "Online-Shop bearbeiten",
      QR_LINK_EDIT: "Link bearbeiten",
      QR_NAME_DESIGN: "Design bearbeiten",
      QR_NAME_SETTING: "Einstellungen bearbeiten",
      QR_NAME_EDIT: "Visitenkarte bearbeiten",
      QR_NAME_EDIT_BPAGE: "Arbeitsseite bearbeiten",
      QR_EDIT_CPAGE: "Website für Gewerbe-/Verwaltungskomplex bearbeiten",
      QR_NAME_INSURANCE: "Online-Versicherung bearbeiten",
      QR_NAME_EDIT_MENU: "Menü bearbeiten",
      QR_NAME_EDIT_APPLICATION: "App bereitstellen",
      QR_NAME_EDIT_APPOINTMENT: "Terminbuchung bearbeiten",
      QR_NAME_EDIT_PHOTO: "Fotogalerie bearbeiten",
      QR_NAME_EDIT_VIDEO: "Videogalerie bearbeiten",
      QR_NAME_EDIT_VOICE: "Audiogalerie bearbeiten",
      QR_NAME_EDIT_FEEDBACK: "Feedback-Galerie bearbeiten",
      QR_NAME_CONSULTATION_QR_EDIT: "Anfrageformular bearbeiten",
      QR_NAME_EDIT_VOICE_PRO: "Audiogalerie (Pro) bearbeiten",
      QR_NAME_EDIT_SOCIAL: "Soziale Netzwerke bearbeiten",
      QR_NAME_STATISTICS: "QR-Code-Statistiken",
      QR_CATE: "Kategorie auswählen",
      QR_SHARE: "Teilen",
      QR_BUSINESS_SHOP: "Geschäft/Shop",
      QR_CO_ORGAN: "Unternehmen/Organisation",
      QR_CONTACT: "Kundenkontakt",
      QR_NOTICES: "Benachrichtigungen",
      QR_OTHERS: "Sonstiges",
      QR_STATICS: "Statischer QR-Code",
      QR_DYNAMICS: "Dynamischer QR-Code",
      QR_D_BUSINESS: "Dynamischer Geschäft QR-Code",
      QR_D_ORGANS: "Dynamischer Organisations-QR-Code",
      QR_D_GOVERNMENT: "Dynamischer Regierungs-QR-Code",
      QR_VIDEO: "Videogalerie",
      QR_APPLICATION: "App bereitstellen",
      QR_VOICE: "Audiogalerie",
      QR_VOICE_PRO: "Audiogalerie (Pro)",
      QR_CONSULTATION_QR: "Anfrageformular",
      QR_FEEDBACK: "Feedback-Galerie",
      QR_PHOTO: "Fotogalerie",
      QR_CATALOG: "Katalog / Broschüre",
      QR_LOCATION: "QR-Code für Standort erstellen",
      QR_SOCIAL_MEDIA: "QR-Code für soziale Netzwerke erstellen",
      QR_LINK: "Link erstellen",
      QR_TEXT: "Text erstellen",
      QR_MAIL: "E-Mail erstellen",
      QR_CALL: "Anruf",
      QR_SMS: "SMS",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "Website",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "WLAN",
      QR_BUSINESS: "Arbeitsseite",
      QR_DISCOUNT: "Rabattseite",
      QR_PRODUCT_SHOP: "Produktvorstellung",
      QR_PRODUCT_LABEL: "Produktlabel",
      QR_GOLD_LABEL: "Goldlabel",
      QR_PRODUCT_TEMPLATE: "Produkte",
      ADMIN_CATEGORY: "Kategorien",
      QR_NFC_ORDERS: "NFC-Karten warten auf Bestätigung",
      QR_NAME_PRODUCT: "Produktvorstellung bearbeiten",
      QR_NAME_LABELPRODUCT: "Produktlabel bearbeiten",
      QR_NAME_GOLDPRODUCT: "Goldlabel bearbeiten",
      QR_COINS: "Kryptowährungen",
      QR_SHOP: "Shop-Management",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "Upload-Center",
      PRICING: "QR-Tarife",
      QR_CREATE_MODELS: "Visitenkartenmodell erstellen",
      QR_CREATE_BUSINESS_MODELS: "Arbeitsseitenmodell erstellen",
      QR_CREATE_PRODUCT_MODEL: "Produktkartenmodell erstellen",
      QR_CREATE_MENU_MODELS: "Shop-Menümodell erstellen",
      QR_CREATE_SHOP_MODEL: "Online-Shop-Modell erstellen",
      MODELS_LIST: "Arten von QR-Modellen",
      MODELS_LIST_EDIT: "Modell bearbeiten",
      MODELS_LIST_MENU_EDIT: "Menümodell bearbeiten",
      MODELS_LIST_BMODEL_EDIT: "Online-Shop-Modell bearbeiten",
      NFC: "NFC-Karten",
      SUBMIT_FORM: "Blogger registrieren",
      REQUEST_LIST: "Bloggerliste",
      PURE_DATA: "Liste nicht erstellter Visitenkarten",
      AUTO_CREATE: "Automatische QR-Code-Erstellung",
      QR_CREATE: "QR-Code erstellen",
      HISTORY_REMINDER: "Erinnerungsüberwachung",
      BOOK: "Erinnerungsüberwachung"
    },
  },
  COMPONENTS: {
    QR_SHOP_MANAGER: {
      PAYMENT_METHODS: "Zahlungsmethoden",
      ORDER_NOTIFICATIONS: "Bestellbenachrichtigungen",
      DISCOUNT_CODE: "Rabattcode",
      CART: "Warenkorb",
      TABLE_MANAGEMENT: "Tischverwaltung",
    },
    ERRORS: {
      INVALID_INPUT: "Bitte Werte korrekt eingeben!",
      CART_SETTINGS_FAILED: "Warenkorb-Einstellungen fehlgeschlagen!",
    },
  },
  popup: {
    prepared_stores_title: "Vorbereitete Online-Shop-Beispiele",
  },
  buttons: {
    reset_defaults: "Standarddaten zurücksetzen",
    download_qr: "QR herunterladen",
    cleardefaults: "Standardinformationen löschen",
    select_prepared_store: "Vorbereiteten Online-Shop auswählen",
  },
  stepper: {
    create_qr: "QR erstellen",
    products_info: "Produkte und Informationen",
    content_settings: "Inhaltseinstellungen",
    sales_settings: "Verkaufseinstellungen",
  },
  fields: {
    online_store_name: "Name des Online-Shops",
    qr_address: "QR-Adresse",
    qr_address_hint: "Geben Sie Ihre QR-Adresse ein",
    online_sale: "Online-Verkauf",
  },
  login_settings: "Anmeldeeinstellungen",
  shop_logo_and_images: "Shop-Logo und Bilder",
  login_page_info: "Informationen zur Anmeldeseite",
  upload_banner: "Banner hochladen",
  create_product: "Produkt erstellen",
  special_sale: "Sonderverkauf",
  ended: "Beendet",
  blog: "Blog",
  services: "Dienstleistungen",
  pdf_gallery: "PDF-Galerie",
  create_section: "Abschnitt erstellen",
  achievements: "Erreichte Erfolge",
  team_members: "Teammitglieder",
  working_hours: "Arbeitszeiten",
  saturday: "Samstag",
  sunday: "Sonntag",
  monday: "Montag",
  tuesday: "Dienstag",
  wednesday: "Mittwoch",
  thursday: "Donnerstag",
  friday: "Freitag",
  we_will_be_different: "Wir werden anders sein...",
  striving_for_excellence:
    "Wir streben immer danach, das Beste zu sein >>> für Sie",
  online_store_ready_15_minutes: "Ihr Online-Shop ist in 15 Minuten fertig!",
  sales_management: "Verkaufsmanagement",
  dear_customer_online_stores:
    "Lieber Kunde, Sie können auch in unseren anderen Online-Shops einkaufen:",
  divar_site: "Divar-Website",
  digikala_site: "Digikala-Website",
  basalam_site: "Basalam-Website",
  torob_site: "Torob-Website",
  emalls_site: "Emalls-Website",
  copyright_qrland: "Alle Rechte vorbehalten für QR Land.",
  tehran_address:
    "Teheran, Shariati-Straße, nach der Seyed Khandan-Brücke, Khandan-Gasse, Nr. 6",
  our_achievements: "Unsere Erfolge",
  customer_satisfaction: "Kundenzufriedenheit",
  lowest_returns: "Niedrigste Rücksendungen",
  loyal_customer: "Treuer Kunde",
  shipped_orders: "Versandte Bestellungen",
  visit_our_videos: "Besuchen Sie unsere Videos.",
  bringing_the_best: "Wir haben das Beste für Sie mitgebracht...",
  feedback_important: "Ihr Feedback ist uns wichtig",
  guide_us_with_feedback:
    "Bitte helfen Sie uns durch Beantwortung der folgenden Fragen, bessere Dienstleistungen zu erbringen.",
  satisfied_with_quality: "Sind Sie mit der Qualität der Waren zufrieden?",
  evaluate_packaging_quality: "Wie bewerten Sie die Verpackungsqualität?",
  satisfied_with_variety: "Sind Sie mit der Vielfalt der Waren zufrieden?",
  benefited_from_discounts:
    "Haben Sie von den Rabatten dieses Shops profitiert?",
  post_1: "Post 1",
  fast_order_delivery: "Schnelle Bestelllieferung",
  post_2: "Post 2",
  post_3: "Post 3",
  product_authenticity_guarantee: "Echtheitsgarantie des Produkts",
  comfortable_purchase: "Ein komfortabler Einkauf",
  how_to_place_order: "Wie kann ich meine Bestellung aufgeben?",
  add_to_cart:
    "Fügen Sie einfach die gewünschten Produkte zum Warenkorb hinzu.",
  how_to_register: "Wie kann ich mich auf der Website registrieren?",
  click_login_and_enter_code:
    "Klicken Sie einfach auf die Schaltfläche „Anmelden“ und geben Sie nach Eingabe Ihrer Mobilnummer den per SMS erhaltenen Code ein.",
  delivery_time:
    "Wie lange dauert es, bis meine Bestellung nach der Registrierung ankommt?",
  fastest_delivery: "Ihre Bestellung wird so schnell wie möglich versandt.",
  shipping_cost: "Wie hoch sind die Versandkosten?",
  shipping_cost_order: "Versandkosten der Bestellung",
  variable_shipping_cost: "Die Versandkosten variieren je nach Ihrer Adresse.",
  change_or_cancel_order:
    "Kann ich meine Bestellung nach der Registrierung ändern oder stornieren?",
  no_change_or_cancel: "Nein. Änderung oder Stornierung ist nicht möglich.",
  mrs_Safdarian: "Frau Safdarian",
  invalid_address: "Die eingegebene Adresse ist ungültig!",
  shop_page_created_success: "Ihre Shop-Seite wurde erfolgreich erstellt.",
  qr_creation_failed: "QR-Erstellung fehlgeschlagen!",
  server_error: "Serverfehler!",
  qr_card_updated_success: "Ihre Visitenkarte wurde erfolgreich bearbeitet.",
  qr_save_edit_failed: "Fehler beim Speichern/Bearbeiten des QR",
  your_feedback: "Ihr Feedback",
  digital_marketing_strategy:
    "Setzen Sie Ihr Unternehmen mit unserem Digital-Marketing-Strategen auf den richtigen Weg",
  wait_for_default_products:
    "Bitte warten Sie, bis die Standardprodukte vollständig auf Ihrer Website geladen sind.",
  template_categories_saved: "Vorlagenkategorien erfolgreich gespeichert.",
  template_products_saved: "Vorlagenprodukte erfolgreich gespeichert.",
  template_products_save_failed: "Fehler beim Speichern der Vorlagenprodukte!",
  template_categories_save_failed:
    "Fehler beim Speichern der Vorlagenkategorien!",
  login_page_text: "Text der Anmeldeseite",
  persian_error: "Der Text muss auf Persisch sein",
  number_error: "Eingabedaten dürfen keine Nicht-Zahlen oder leer sein",
  english_error: "Der Text darf nicht nicht-englisch oder leer sein",
  mixPerEng_error:
    "Der Text darf nicht nicht-englisch oder nicht-persisch oder leer sein",
  email_error: "Das eingegebene E-Mail-Format ist ungültig",
  mobile_error: "Das eingegebene Nummernformat ist ungültig",
  meliCode_error: "Das eingegebene nationale Code-Format ist ungültig",
  site_error: "Das eingegebene Website-Format ist ungültig",
  min_length_error: "Der eingegebene Wert darf nicht kleiner als {{min}} sein",
  max_length_error: "Der eingegebene Wert darf nicht größer als {{max}} sein",
  form_submitted_message: "Ihr Formular wurde erfolgreich gesendet",
  required_fields_error: "Pflichtwerte wurden nicht eingegeben",
  headphone_title: "Kopfhörer",
  buy_button: "Kaufen",
  day: "Tag",
  hour: "Stunde",
  minute: "Minute",
  second: "Sekunde",
  required_field_error: "{{fieldName}} ist erforderlich",
  submit_request_button: "Anfrage senden",
  request_submitted_success: "Ihre Anfrage wurde erfolgreich registriert",
  feedback_submitted_success: "Ihr Feedback wurde erfolgreich registriert",
  description_required_label: "Beschreibung (erforderlich)",
  description_optional_label: "Beschreibung (optional)",
  description_hint:
    "Bitte geben Sie Ihre gewünschte Beschreibung in dieses Feld ein (mindestens 3 Zeichen)",
  footer: {
    position: "Seite",
    contactUs: "Kontaktieren Sie uns",
    aboutUs: "Über uns",
    firstShift: "Erste Schicht",
    secondShift: "Zweite Schicht",
    startTime: "Startzeit",
    endTime: "Endzeit",
    features: "Funktionen",
    partners: "Partner",
    affiliates: "Affiliate-Programme",
    panels: "Panels",
    supportTicket: "Support-Ticket",
    inPersonServices: "Persönliche Dienstleistungen",
    liveChat: "Live-Chat",
    faq: "Häufig gestellte Fragen",
    add_secondshift: "Zweite Schicht hinzufügen",
    firstDate: "Startdatum",
    endDate: "Enddatum",
  },
  qr_management: "QR-Management",
  restore_default_questions: "Standardfragen wiederherstellen",
  delete_all: "Alle löschen",
  edit_question: "Frage bearbeiten",
  move_up: "Nach oben",
  move_down: "Nach unten",
  delete: "Löschen",
  selected_question: "Ausgewählte Frage",
  question: "Frage",
  answer_type: "Antworttyp",
  excellent: "Ausgezeichnet",
  good: "Gut",
  very_poor: "Sehr schlecht",
  response_optionality: "Antwort optional / erforderlich",
  required: "Erforderlich",
  optional: "Optional",
  add_new_question: "Neue Frage hinzufügen",
  satisfied_with_quality: "Sind Sie mit der Qualität der Waren zufrieden?",
  evaluate_packaging_quality: "Wie bewerten Sie die Verpackungsqualität?",
  satisfied_with_variety: "Sind Sie mit der Vielfalt der Waren zufrieden?",
  benefited_from_discounts:
    "Haben Sie von den Rabatten dieses Shops profitiert?",
  suggestions_for_improvement:
    "Welchen Vorschlag haben Sie zur Verbesserung des Einkaufserlebnisses in diesem Shop?",
  confirm_delete_question: "Ausgewählte Frage löschen?",
  question_deleted_success: "Frage erfolgreich gelöscht.",
  question_delete_failed: "Fehler beim Löschen der Frage!",
  confirm_delete_all_questions:
    "Sind Sie sicher, dass Sie alle Fragen löschen möchten?",
  questions_deleted_success: "Fragen erfolgreich gelöscht.",
  questions_delete_failed: "Fehler beim Löschen der Fragen!",
  invalid_input: "Bitte Werte korrekt eingeben!",
  operation_failed: "Operation fehlgeschlagen!",
  question_number: "Frage {number}?",
  card_subtitle:
    "Geben Sie einfach die Geschichte des gewünschten Bildes ein, und die KI erstellt es für Sie.",
  upgrade_label: "Anhängen",
  free: " - Kostenlos",
  language_select: "Sprache für die Anfragetext-Eingabe auswählen",
  image_size: "Bildgröße",
  prompt_label: "Anfragetext",
  prompt_placeholder: "Beschreiben Sie das gewünschte Bild...",
  generate_image: "Bild generieren",
  regenerate_image: "Neues Bild generieren",
  save_image: "Bild speichern",
  save_image_subtitle: "Nur das oben angezeigte Bild wird gespeichert.",
  size_items: {
    "16:9": "16:9 (horizontal)",
    "9:16": "9:16 (vertikal)",
    "1:1": "1:1 (quadratisch)",
  },
  lang_items: {
    fa: "Fa | Persisch",
    en: "En | Englisch",
    ar: "Ar | Arabisch",
  },
  rules: {
    empty: "Mindestens 3 Zeichen eingeben!",
    spell_checker: "Der eingegebene Text muss in der Sprache {language} sein!",
  },
  ERRORS: {
    VpnDetectedTitle: "Bitte VPN deaktivieren",
    VpnDetectedSubtitle:
      "Dies hilft dem System, besser zu funktionieren und Ihnen eine bessere Erfahrung zu bieten.",
  },
  errors: {
    VpnDetectedTitle: "Bitte VPN deaktivieren",
    VpnDetectedSubtitle:
      "Dies hilft dem System, besser zu funktionieren und Ihnen eine bessere Erfahrung zu bieten.",
    invalid_size: "Bitte Breite und Höhe korrekt eingeben!",
    image_generation_error: "Fehler bei der Bildgenerierung",
    image_upload_error: "Fehler beim Hochladen des Bildes!",
    service_unavailable:
      "Dieser Dienst ist nicht verfügbar – Beim Laden der Daten vom Server ist ein Fehler aufgetreten",
    qr_address_taken: "Diese QR‑Adresse ist bereits vergeben",
  },
  add_working_time: "Arbeitszeit hinzufügen",
  selected_day: "Ausgewählter Tag",
  range_name: "Name des Zeitraums",
  add: "Hinzufügen",
  first_shift: "Erste Schicht",
  second_shift: "Zweite Schicht",
  start_time: "Startzeit",
  end_time: "Endzeit",
  date_range: "Zeitraum",
  all_week_days: "Alle Wochentage",
  saturday_to_wednesday: "Samstag bis Mittwoch",
  saturday_to_thursday: "Samstag bis Donnerstag",
  work_week: "Alle Wochentage (außer Feiertage)",
  feedbacks: "Feedbacks",
  failed_retrieve_feedback: "Abruf der Feedbacks fehlgeschlagen!",
  province: "Provinz",
  search_city_placeholder: "Suchen Sie nach dem gewünschten Stadtnamen.",
  search_city_label: "Stadtsuche",
  welcome: "Willkommen in unserer App",
  description: "Dies ist eine mehrsprachige App.",
  soon: "Bald",
  beta_version: "Beta-Version",
  defaults_cleared_success: "Standarddaten erfolgreich gelöscht",
  defaults_reset_success: "Standarddaten erfolgreich zurückgesetzt",
  select_navigator_after_location_click:
    "Nach Klick auf den Standort den gewünschten Navigator auswählen",
  no_address_selected: "Keine Adresse ausgewählt",
  no_location_selected: "Kein Standort ausgewählt",
  region: "Region",
  api_unauthorized: "Authentifizierungsfehler: Ungültiger API-Schlüssel",
  location_not_found: "Standort nicht gefunden",
  addCategory: "Neue Kategorie hinzufügen",
  editCategory: "Kategorie bearbeiten",
  deleteCategory: "Ausgewählte Kategorie löschen?",
  addProduct: "Neues Produkt hinzufügen",
  saveProducts: "Standardprodukte auswählen",
  addSubCategory: "Unterkategorie hinzufügen",
  product: "Produkt",
  categoryName: "Kategoriename",
  subCategoryName: "Name der Unterkategorie",
  confirmDeleteProduct: "Soll das Produkt aus der Kategorie entfernt werden?",
  successMessages: {
    categorySaved: "Kategorien erfolgreich gespeichert.",
    productSaved: "Produkte erfolgreich gespeichert.",
    productDeleted: "Produkt erfolgreich gelöscht.",
  },
  errorMessages: {
    saveCategoryFailed: "Fehler beim Speichern der Kategorien!",
    saveProductFailed: "Fehler beim Speichern der Produkte!",
    deleteCategoryFailed: "Fehler beim Löschen der Kategorie!",
  },
  add_edit_categories: "Kategorie hinzufügen/bearbeiten",
  copy_category: "Kategorie kopieren",
  product: "Produkt {point}",
  copy_product: "Produkt kopieren",
  add_edit_products: "Produkte hinzufügen/bearbeiten",
  copy_category: "Kategorie kopieren",
  edit_category: "Kategorie bearbeiten",
  category_name: "Kategoriename",
  edit_subcategory: "Unterkategorie bearbeiten",
  subcategory_name: "Name der Unterkategorie",
  add_new_category: "Neue Kategorie hinzufügen",
  store_management: "Shop-Verwaltung",
  manage_products: "Produktverwaltung",
  products_export: "Produkte herunterladen",
  "UPLOAD_EXCEL.UPLOAD_TITLE": "Excel-Datei hochladen",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1": "Ziehe deine Excel-Datei hierher oder",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2": "wähle sie aus",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3": "zum Hochladen",
  "UPLOAD_EXCEL.INVALID_FILE_TYPE": "Bitte nur Excel-Dateien (.xlsx) hochladen",
  "GENERAL.SUBMIT": "Absenden",
  "GENERAL.CANCEL": "Abbrechen",
  "GENERAL.SUCCESSFULLY_ADDED": "Produkte erfolgreich hochgeladen",
  SUCCESSFULLY_DOWNLOADED: "Produkte erfolgreich heruntergeladen",
  "GENERAL.ERROR": "Ein Fehler ist aufgetreten",
  EditSubCategoty: "Unterkategorie bearbeiten",
  create: "Erstellen",
  save_changes: "Änderungen speichern",
  buy_button_settings: "Einstellungen für den Kauf-Button",
  image: "Bild",
  color: "Farbe",
  title: "Titel",
  price: "Preis",
  discount: "Rabatt",
  percent: "Prozent",
  amount: "Betrag",
  brand: "Marke",
  inventory: "Lagerbestand",
  inventory_hint: "Leer = unbegrenzte Bestellmenge",
  order_limit: "Max. Menge pro Bestellung",
  order_limit_hint: "Leer = keine Begrenzung.",
  packing_price: "Verpackungskosten",
  packing_price_hint:
    "Wird bei externer Bestellung (Kurier/Vor-Ort-Abholung) angewendet.",
  description: "Beschreibung",
  options: "Optionen",
  product_features: "Produktmerkmale",
  field_required: "Pflichtfeld.",
  min_length: "Mindestens 3 Zeichen erforderlich.",
  product: "Produkt",
  default_brand: "Apple",
  product_added_success: "Produkt erfolgreich hinzugefügt",
  product_added_error: "Fehler beim Hinzufügen des Produkts",
  whole_categories: "(Alle Kategorien)",
  add_select_category: "Kategorie hinzufügen/auswählen",
  select_default_category: "Standardkategorie auswählen",
  deleted_product: "Produkt löschen",
  confirm_delete_prooduct:
    "Soll das Produkt aus der Kategorie entfernt werden?",
  please_wait_store_product: "Produkte werden gespeichert, bitte warten...",
  saved_product_success: "Produkte erfolgreich gespeichert.",
  error_in_store: "Fehler beim Speichern",
  delete_category: "Kategorie löschen",
  confirm_delete_category: "Kategorie erfolgreich gelöscht.",
  error_delete_category: "Fehler beim Löschen der Kategorie!",
  productOptionEditor: {
    tabs: {
      color: "Farbe",
      size: "Größe",
      count: "Anzahl",
      weight: "Gewicht",
      type: "Typ/Geschlecht",
    },
    fields: {
      count: "Anzahl",
      max_order: "Max. Bestellmenge",
      price: "Preis",
      discount: "Rabatt",
      color: "Farbe",
      color_name: "Farbname",
      inventory: "Lagerbestand",
      size: "Größe",
      type: "Typ/Geschlecht",
      weight: "Gewicht",
    },
    actions: {
      delete: "Löschen",
      add_location: "Option hinzufügen",
    },
  },
  extraSubProducts: {
    feature: "Merkmal",
    name_label: "Name",
    name_placeholder: "Beispiel: Extra-Soße / Zusätzliches Brot",
    price_label: "Preis",
    price_hint: "Leer = kostenloses Zusatzprodukt.",
    price_placeholder: "Beispiel: Wasser, Typ (z. B. Hähnchenbrust/Schenkel)",
    add_subproduct: "Zusatzprodukt hinzufügen",
  },
  error_selected_category: "Fehler bei der Kategoriewahl!",
  suggestinput: {
    title: "Emoji auswählen",
    aboutUs: "Über uns",
    error: "Fehler",
    errorMessage: "Bitte lade dein Guthaben auf und versuche es erneut.",
    generateText: "KI-Textvorschlag",
    emoji: "Emoji",
    errorMessage_400:
      "Fehler beim Erstellen des 'Über uns'-Textes. Bitte erneut versuchen.",
    errorMessage_403:
      "Fehler beim Erstellen des 'Über uns'-Textes. Kaufe ein Paket und versuche es erneut",
  },
  togetherai: {
    buy_package: "Paket kaufen",
    tax_notice: "10 % Mehrwertsteuer wird auf den Paketpreis hinzugerechnet!",
    package: "Paket",
    rial: "Rial",
    buy_button: "Kaufen!",
    discount_label: "Rabattcode",
    submit_discount: "Einlösen",
    success_message: "Dein QR wurde erfolgreich hochgestuft.",
    error_insufficient_funds:
      "Prüfe dein Guthaben und versuche es später erneut.",
    error_upgrade: "Fehler beim Upgraden des QR!",
    error_title: "Fehler",
    success_title: "Erfolg",
  },
  category_not_found: "Kategorie nicht gefunden!",
  create_upload_category: "Kategorie erstellen und hochladen",
  add_subcategory: "Unterkategorie hinzufügen",
  error_upload_m_video:
    "Fehler beim Hochladen des Videos (möglicherweise eingeschränkter Zugriff).",
  info_show_video: "Für mehr anzeigen auf 'Mehr' klicken.",
  error_not_valid_guide_id: "Ungültige Anleitungs-ID!",
  error_give_guide_info: "Fehler beim Abrufen der Anleitungsinformationen!",
  info_success_saved: "Erfolgreich gespeichert",
  error_add_new_guide: "Fehler beim Hinzufügen einer neuen Anleitung",
  popup: {
    details: "Details",
    guide_images: "Anleitungsbilder",
    guide_videos: "Anleitungsvideos",
    faq: "FAQ",
    no_title: "Kein Titel",
    no_content: "Kein Inhalt zum Anzeigen",
    no_questions: "Keine Frage zum Anzeigen",
    video_error:
      "Fehler beim Hochladen des Videos (möglicherweise eingeschränkter Zugriff)",
    no_answer: "Keine Antwort",
    question_no_title: "Frage ohne Titel",
    default_title: "Anleitung",
  },
  productPicker: {
    select_default_product: "Standardprodukt auswählen",
    search: "Suche",
    select_all_products: "Alle Produkte auswählen",
    back: "Zurück",
    no_products_in_category: "Keine Produkte in dieser Kategorie!",
    products_error: "Fehler beim Laden der Produkte!",
    retry: "Erneut versuchen",
    items_per_page: "Einträge pro Seite",
    root_breadcrumb: "/",
  },
  end_date: "Enddatum",
  filters: {
    userType: {
      legal: "Juristische Person",
      individual: "Privatperson",
    },
    serviceType: {
      Payamakland: "Payamakland",
      Coreland: "Coreland",
      Qrland: "Qrland",
      Robotland: "Robotland",
      billboard: "Werbetafel",
      tablighNegar: "TablighNegar",
      unknown: "Unbekannt",
    },
    qrType: {
      gift: "Erinnerungsrahmen",
      instagram: "Instagram",
      visitCard: "Visitenkarte",
      Business: "Privat / Unternehmen",
      Commericial: "Website für Gewerbe- / Bürokomplex",
      qrlink: "QR-Link",
      labelproduct: "Produktetikett",
      goldLabel: "Goldetikett",
      bShop: "Shop",
      SocialMedia: "Soziale Netzwerke",
      VideoGallery: "Videogalerie",
      PhotoGallery: "Fotogalerie",
      voiceGallery: "Audiogalerie",
      consultationQr: "Anfrageformular",
      application: "App",
      feedbackGallery: "Feedback",
      voiceGalleryPro: "Professionelle Audiogalerie",
      singleProduct: "Produktvorstellung",
      menu: "Speisekarte",
      appointment: "Terminvereinbarung",
      insurance: "Versicherung",
      text: "Text",
      luck_wheel: "Glücksrad",
      pdfgallery: "PDF-Galerie",
      productpro: "Professionelle Produktvorstellung",
      multicard: "Multi-Karte",
      catalog: "Katalog",
      visitCard_pro: "Pro-Visitenkarte",
      clickyarseo: "ClickYar SEO QR",  
      },
    expire: {
      day: "Tag",
      expired: "Abgelaufen",
    },
    numericPersianNumber: {
      thousand: "Tausend",
      million: "Million",
    },
    dateString: {
      at: "um",
    },
    messages: {
      pleaseLogin: "Bitte melde dich an",
      invalidPhone: "Ungültige Telefonnummer",
      copied: "Kopiert",
    },
  },
  nextButton: "Weiter",
  previousButton: "Zurück",
  rowsPerPageText: "Einträge pro Seite",
  noDataText: "Keine Daten zum Anzeigen",
  placeholderSearch: "Suchen..",
  set_qr: "QR registriert",
  numbers: "Nummern",
  enter_param_product: "Produktdaten korrekt eingeben!",
  instagram_hint: "Dein Instagram eingeben",
  whatsapp_hint: "Dein WhatsApp eingeben",
  telegram: "Telegram",
  telegram_hint: "Dein Telegram eingeben",
  userpicker: {
    select_user: "Benutzer auswählen",
    choice_users: "Benutzer auswählen",
    id: "ID",
    phone_number: "Mobilnummer",
    date_created: "Erstellungsdatum",
    info_edit: "Informationen bearbeiten",
    name_family: "Vor- und Nachname",
    position: "Position und Rang",
    phone: "Telefonnummer",
    discription: "Beschreibung",
  },
  search_product: "Produkt suchen",
  search_name_product: "Produktname suchen",
  search_name_product: "Produktname suchen",
  search_product: "Produkt suchen",
  currency: "Rial",
  headers: {
    index: "Reihenfolge",
    gallery: "Bild",
    id: "ID",
    name: "Name",
    brand: "Marke",
    price: "Betrag",
    discount_amount: "Rabatt",
  },
  search_categories: "In Kategorien suchen",
  search_categories: "Suchen ",
  delete_all: "Alle löschen",
  select_category: "Kategorie auswählen",
  currency1: "Iranischer Rial", // Währungseinheit Iran (Rial)
  features: "Merkmale",
  product_sp: {
    edit: "Bearbeiten",
    back: "Zurück",
    save: "Speichern",
    add_product_to_special_category:
      "Fülle die Felder aus, um das Produkt zur Sonderkategorie hinzuzufügen",
    inventory: "Lagerbestand",
    discount: "Rabatt",
    max_per_customer: "Max. pro Kunde",
    max_per_order: "Max. pro Bestellung",
    expires_at: "Ablaufdatum",
    field_cannot_be_empty: "Feld darf nicht leer sein.",
    please_enter_correctly: "Bitte korrekt ausfüllen!",
    currency: "Iranischer Rial", // Währungseinheit Iran (Rial)
  },
  selectproduct: "Produkt auswählen",
  section: {
    edit_part: "Abschnitt bearbeiten",
    title: "Titel",
    position_text: "Textposition",
    add_video: "Video hinzufügen",
    text: "Text",
    address_video: "Video-URL",
    position_left: "Links",
    position_right: "Rechts",
    tab_edit_button: "Button bearbeiten",
    tab_content: "Abschnittsinhalt",
  },
  name_shopping: "Shop-Name",
  hint_shopping: "Gib deinen Shop-Namen ein.",
  title_discount: "Rabatt-Titel",
  hint_discount: "Gib deinen Rabatt-Titel ein.",
  hint_mount_discount: " 20 % Rabatt auf deine nächste Bestellung.",
  label_discount: "Rabattbetrag eingeben",
  give_discount: "Rabattcode erhalten",
  give_copon: "Gutschein erhalten",
  enter_copon: "Gutschein eingeben",
  hint_phone: "Gib deine Telefonnummer ein.",
  label_phone: "Telefonnummer",
  hint_condition_discount: "Beschreibe die Rabattbedingungen..",
  label_discription_discount: "Rabattbeschreibung",
  add_info_discount: "Füge zusätzliche Infos hinzu:",
  enter_address_discount: "Gib deine Adresse ein.",
  address_discount: "Adresse",
  edit_feedback: "Feedback bearbeiten",
  select_type_replay: "Antworttyp auswählen",
  field_discription: "Beschreibungsfeld",
  messages_discription:
    "Aktiviere dies, um ein Beschreibungsfeld für den Nutzer anzuzeigen",
  number_char: "Zeichenanzahl muss zwischen 3 und 50 liegen!",
  search: "Suchen",
  no_videos_found: "Keine Videos gefunden!",
  upload_video_prompt:
    "Verwende den Video-Upload-Bereich, um eine Datei hinzuzufügen",
  delete_success: "Erfolgreich gelöscht.",
  tabs: {
    qr_view: "QR-Ansicht",
    preview: "Vorschau",
    ready_video: "Fertigvideo",
    video_gallery: "Videogalerie",
    link: "Link",
    video_upload: "Video hochladen",
  },
  consultation: {
    name: "Vorname",
    surname: "Nachname",
    phone: "Mobilnummer",
    nationalId: "Personalausweisnummer",
    nationalIdAuthenticate: "Personalausweis verifizieren",
    nationalIdCorrect: "Gültigkeit der Personalausweisnummer prüfen",
    mail: "E-Mail",
    address: "Adresse",
    location: "Standort",
    custom: "Anpassbar",
    customLabel: "Titel",
    customOptions: "Optionen",
    optional: "Optional",
    require: "Pflichtfeld",
    description: "Beschreibung",
  },
  add_section: "Abschnitt hinzufügen",
  add_new_text_section:
    "Sie sind herzlich eingeladen in das intelligente digitale Land von QR-Land.",
  btn_title_section: "Kostenlose Registrierung",
  shop: {
    step_products_and_info: "Produkte & Informationen",
    online_store_name: "Name des Online-Shops",
    qr_address: "QR-Adresse",
    qr_address_hint: "Gib deine QR-Adresse ein",
    online_sale: "Online-Verkauf",
    step_content_settings: "Inhaltseinstellungen",
    step_sale_settings: "Verkaufseinstellungen",
    download_qr: "QR herunterladen",
    login_settings: "Login-Einstellungen",
    store_logo_images: "Shop-Logo und Bilder",
    login_page_info: "Login-Seiteninformationen",
    upload_banner: "Banner hochladen",
    user_info: "Benutzerinformationen",
    create_product: "Produkt erstellen",
    special_sale: "Sonderverkauf",
    add_social_media: "Soziale Medien hinzufügen",
    blog: "Blog",
    services: "Dienstleistungen",
    faq: "FAQ",
    photo_gallery: "Fotogalerie",
    video_gallery: "Videogalerie",
    pdf_gallery: "PDF-Galerie",
    feedback: "Feedback",
    countdown: "Countdown",
    request_form: "Anfrageformular",
    create_section: "Abschnitt erstellen",
    achievements: "Erfolge",
    team_members: "Teammitglieder",
    working_hours: "Öffnungszeiten",
    error_saving_content: "Fehler beim Speichern der Inhaltseinstellungen!",
    success_edit_store: "Shop-Seite erfolgreich bearbeitet.",
    post_1: "Beitrag 1",
    logo: "Logo",
    background_image: "Hintergrundbild",
  },
  discount_obj: {
    quantity: "Menge",
    create_edit_code: "Rabattcode erstellen/bearbeiten",
    coding_type_label: "Erstellungsart",
    coding_type_single: "Einzeln",
    coding_type_group: "Gruppe",
    status_label: "Status",
    status_active: "Aktiv",
    status_deactivate: "Deaktiviert",
    discount_code: "Rabattcode",
    discount_type: "Rabattart",
    discount_type_percent: "Prozentual",
    discount_type_fixed: "Fester Betrag",
    discount_value: "Rabattwert",
    discount_limit: "Rabattgrenze",
    no_limit: "Keine Begrenzung",
    tab_create_discount: "Rabattcode erstellen",
    tab_settings: "Einstellungen",
    success_create: "Rabattcode erfolgreich erstellt",
    success_edit: "Rabattcode erfolgreich bearbeitet",
    error_value_empty: "Rabattwert darf nicht leer sein!",
    error_start_time: "Kein Startzeitpunkt ausgewählt!",
    error_end_time: "Kein Endzeitpunkt ausgewählt!",
    error_same_time: "Start- und Endzeit dürfen nicht identisch sein",
  },
  personnel: {
    team_members: "Ausgewählte Teammitglieder",
    add_team_member: "Teammitglied hinzufügen",
    default_position: "Position und Rang",
    default_phone: "Telefonnummer",
    default_full_name: "Vollständiger Name",
    default_description:
      "Lorem Ipsum ist ein einfacher Blindtext der Druckindustrie, den Designer seit Jahrhunderten verwenden",
  },
  discount_settings: {
    function_type: {
      title: "Rabattfunktion",
      all_shopping_cart: "Gesamtbetrag des Warenkorbs",
      special_products: "Spezielle Produkte",
      special_categories: "Spezielle Kategorien",
    },
    basket_condition: {
      title: "Warenkorb-Bedingungen",
      no_conditions: "Keine Bedingungen",
      minimum_shopping: "Mindestbetrag im Warenkorb",
      minimum_product: "Mindestanzahl Produkte im Warenkorb",
      maximum_shopping: "Höchstbetrag im Warenkorb",
      maximum_product: "Höchstanzahl Produkte im Warenkorb",
    },
    user_settings: {
      title: "Benutzereinstellungen",
      all_user: "Alle Benutzer",
      group: "Benutzergruppe",
      special: "Spezielle Benutzer",
    },
    limitation_use: {
      title: "Nutzungsbeschränkung",
      no_limitations: "Keine Beschränkungen",
      discount_code: "Anzahl Nutzungen des Rabattcodes",
      user: "Nutzungen pro Benutzer",
    },
    start_time: {
      title: "Rabatt-Startdatum",
      no_time_selected: "Kein Startzeitpunkt ausgewählt",
    },
    end_time: {
      title: "Rabatt-Enddatum",
      no_time_selected: "Kein Endzeitpunkt ausgewählt",
    },
  },
  counterService: {
    typeLabel: "Anzeigetyp",
    number: "Zahl",
    percent: "Prozent",
    iconLabel: "Icon",
    counterLabel: "Wert",
    linkLabel: "Link",
    nameLabel: "Titel",
    addButton: "Erfolg hinzufügen",
    successful: {
      added: "Element erfolgreich hinzugefügt",
      removed: "Element erfolgreich entfernt",
      movedUp: "Element erfolgreich nach oben verschoben",
      movedDown: "Element erfolgreich nach unten verschoben",
    },
  },
  qrUsersList: {
    customersList: "Kundenliste",
    orders: "Bestellungen",
    addresses: "Adressen",
    hasAssistantsMobile_hint: "Mobilnummer auswählen",
    invalidPhone: "Die eingegebene Mobilnummer ist ungültig",
    validation: {
      nameRequired: "Vorname ist erforderlich",
      nameMinLength: "Vorname muss mindestens 2 Zeichen lang sein",
      familyRequired: "Nachname ist erforderlich",
      familyMinLength: "Nachname muss mindestens 2 Zeichen lang sein",
    },
    addUser: "Benutzer hinzufügen",
    registerOnline: "Online-Registrierung aktivieren",
    usersColumns: {
      id: "ID",
      name: "Vorname",
      family: "Nachname",
      mobile: "Mobilnummer",
      subscriptionId: "Abo-ID",
      ordersCount: "Bestellanzahl",
      lastLogin: "Letzter Login",
      status: "Status",
      activeUser: "Aktiver Benutzer",
      none: "-",
      actions: "Aktionen",
      buttons: {
        info: "Kundendaten",
        sendSms: "SMS senden",
        history: "Verlauf",
        addresses: "Adressen",
        orders: "Bestellungen",
      },
    },
    orderColumns: {
      orderId: "Bestellnummer",
      customerName: "Kundenname",
      mobile: "Mobilnummer",
      paymentMethod: "Zahlungsmethode",
      shippingMethod: "Versandart",
      orderAmount: "Bestellbetrag",
      orderTime: "Bestellzeit",
      status: "Status",
      currency: "Rial",
    },
    addressesColumns: {
      id: "#",
      addressTitle: "Adresstitel",
      name: "Vorname",
      family: "Nachname",
      mobile: "Telefon",
      address: "Adresse",
      zipCode: "PLZ",
      number: "Hausnummer",
      unit: "Einheit",
    },
    shippingType: {
      courier: "Kurier",
      reservation: "Tischreservierung",
      place: "Vor-Ort-Abholung",
      none: "-",
    },
    paymentType: {
      online: "Online-Zahlung",
    },
    perPage: "Einträge pro Seite",
    search: "Suchen",
    sortColumn: "Sortieren nach",
    sortDirection: "Sortierrichtung",
    sortDirectionDesc: "Absteigend",
    sortDirectionAsc: "Aufsteigend",
    noStatus: "Kein Status gefunden",
    status: {
      all: "Alle",
      active: "Aktiv",
      inactive: "Inaktiv",
    },
    fetchError: "Fehler beim Laden der Benutzerdaten",
  },
  listCardHeader: {
    clear_filters: "Filter zurücksetzen",
    group_qr_renewal: "Massenverlängerung von QR-Codes",
    select_desired_duration: "Gewünschte Laufzeit auswählen",
    total_count: "Gesamtanzahl",
    final_amount: "Endbetrag",
    ten_percent_vat_will_be_added: "10 % MwSt. wird hinzugerechnet",
    pay_and_upgrade: "Bezahlen & Upgraden",
    no_tariff_for_this_period: "Keine Tarife für diesen Zeitraum",
    one_month_renewal: "Monatsverlängerung",
    three_month_renewal: "3-Monats-Verlängerung",
    six_month_renewal: "6-Monats-Verlängerung",
    one_year_renewal: "Jahresverlängerung",
    selected: "Ausgewählt",
    view: "Anzeigen",
    details: "Details",
    total_amount: "Gesamtbetrag",
    discount: "Rabatt",
    final_amount_with_discount: "Endbetrag mit Rabatt",
    add_qr: "QR hinzufügen",
    select_all: "Alle auswählen",
    actions: "Aktionen",
    filter: "Filter",
    type_filter: "Typfilter",
    start_from: "Beginnt mit",
    search: "Suchen",
    id_search: "ID-Suche",
    filter_user: "Benutzerfilter",
    sort: "Sortieren",
    send_sms: "SMS senden",
    selected_pattern: "Ausgewähltes Muster:",
    send: "Senden",
    newest: "Neueste",
    oldest: "Älteste",
    most_visited: "Am häufigsten besucht",
    least_visited: "Am seltensten besucht",
    pause: "Pausieren",
    bulk_download: "Massen-Download",
    activate: "Aktivieren",
    deactivate: "Deaktivieren",
    error_loading_card: "Fehler beim Laden der Kartendaten!",
    error_fetching_prices: "Fehler beim Abrufen der Preise!",
    error_payment: "Fehler bei der Zahlung!",
    sms_success: "SMS erfolgreich gesendet",
    generic_error: "Ein Fehler ist aufgetreten!",
  },
  headerTypeFilter: {
    qr_model: "QR-Modell",
    all_qr_models: "Alle QR-Modelle",
  },
  menuOrderFactor: {
    order_invoice: "Bestellrechnung",
    total: "Gesamt",
    tax: "Steuer",
    shipping_cost: "Versandkosten",
    packing_cost: "Verpackungskosten",
    discount: "Rabatt",
    final_total: "Endbetrag",
    currency: "Rial",
    titles: {
      default_title: "Standardbestellung",
    },
  },
  headerSearchTypeFilter: {
    search_in_list: "In Liste suchen",
    search: "Suchen",
    start_from: "Beginnt mit",
  },
  headerStatusFilter: {
    all_qr_codes: "Alle QR-Codes",
    active_qr_codes: "Aktive QR-Codes",
    inactive_qr_codes: "Inaktive QR-Codes",
    expiring_qr_codes: "Bald ablaufende QR-Codes",
    expired_qr_codes: "Abgelaufene QR-Codes",
  },
  qrOrdersList: {
    title: "Bestellliste",
    orderColumns: {
      index: "Reihenfolge",
      id: "Bestellnummer",
      customerName: "Kundenname",
      mobile: "Mobilnummer",
      paymentType: "Zahlungsmethode",
      shippingType: "Versandart",
      price: "Bestellbetrag",
      createdAt: "Bestellzeit",
      status: "Status",
      actions: "Aktionen",
    },
    productsColumns: {
      productId: "Produkt-ID",
      image: "Bild",
      productName: "Produktname",
      unitPrice: "Einzelpreis",
      quantity: "Menge",
      totalPrice: "Gesamtpreis",
    },
    actions: {
      products: "Bestellliste",
      print: "Bestellung drucken",
      share: "Bestellung teilen",
      status: "Status ändern",
    },
    shippingType: {
      courier: "Kurier",
      reservation: "Tischreservierung",
      place: "Vor-Ort-Abholung",
      post: "Postversand",
      unknown: "-",
    },
    paymentType: {
      online: "Online-Zahlung",
      place: "Zahlung vor Ort",
      unknown: "-",
      card2card: "Karte-zu-Karte-Zahlung",
    },
    status: {
      all: "Alle",
      pending: "Zahlung ausstehend",
      accepted: {
        place: "Zahlung vor Ort",
        paid: "Bezahlt",
      },
      delivered: "Geliefert",
      rejected: "Zahlung fehlgeschlagen",
    },
    factorTitle: "Bestellrechnung",
    printFactor: "Rechnung drucken",
    fetchError: "Fehler beim Laden der Daten",
    statusChanged: "Status erfolgreich geändert",
    statusChangeError: "Fehler beim Ändern des Status",
    currency: "Rial",
    perPage: "Anzahl",
    search: "Suchen",
    noStatus: "Kein Status",
    loading: "Lade...",
    noShippingType: "Kein Versandtyp",
    noPaymentType: "Kein Zahlungstyp",
    sortColumn: "Sortierspalte",
    sortDirection: "Sortierrichtung",
    sortDirectionDesc: "Absteigend",
    sortDirectionAsc: "Aufsteigend",
    selectNewStatus: "Neuen Status auswählen",
    changeStatusTitle: "Status ändern",
    linkCopied: "Link kopiert.",
  },
  qrUserTransfer: {
    title: "Eigentümerwechsel",
    radioLabels: {
      userTransfer: "An andere Person übertragen",
      givingAccess: "Zugriff gewähren",
    },
    inputLabels: {
      phone: "Mobilnummer der Person",
    },
    hints: {
      addNumber: "Zum Hinzufügen Enter oder + drücken",
      addNumberStep2: "Zum Hinzufügen Enter oder + drücken",
    },
    buttons: {
      transfer: "Übertragen",
      giveAccess: "Zugriff gewähren",
      back: "Zurück",
      saveChanges: "Änderungen speichern",
      cancel: "Abbrechen",
        "add": "Hinzufügen"

    },
    tooltips: {
      deleteAccess: "Zugriff entfernen",
    },
    subtitles: {
      accessList: "Liste der Zugriffsberechtigten:",
      selectPermissions: "Berechtigungen auswählen:",
    },
    permissionList: {
      edit_name: "Dienstname bearbeiten",
      edit_link: "Link bearbeiten",
      edit_info: "Informationen bearbeiten",
      edit_design: "QR-Design bearbeiten",
      edit_settings: "QR-Einstellungen bearbeiten",
      toggle_access: "Zugriff aktivieren/deaktivieren",
      view_customers: "Kundenliste anzeigen",
      view_orders: "Bestellliste anzeigen",
    },
    messages: {
      invalidPhone: "Ungültige Telefonnummer",
      duplicatePhone: "Doppelte Nummer nicht erlaubt",
      updateAccessSuccess: "Zugriffe erfolgreich aktualisiert.",
      updateAccessError: "Fehler beim Aktualisieren: {message}",
      deleteAccessSuccess: "Zugriff erfolgreich entfernt.",
      deleteAccessError: "Fehler beim Entfernen: {message}",
      fetchAccessError: "Fehler beim Laden: {message}",
      transferSuccess: "QR erfolgreich übertragen.",
      transferError: "Fehler bei der Übertragung: {message}",
      giveAccessSuccess: "Erfolgreich eingerichtet.",
      giveAccessError: "Fehler beim Einrichten: {message}",
      confirmDeleteAccess: "Zugriff dieser Person wirklich entfernen?",
    },
  },
  form: {
    form_download: "Empfangene Formulare",
    form_add: "Formular hinzufügen",
    formdownload: "Empfangenes Formular",
    create_at: "Erstellt am :",
    shown: "Angezeigt",
    nogiveform: "Du hast kein empfangenes Formular",
    back: "Zurück",
    invalid_date: "Ungültiges Datum",
    select_date: "Datum auswählen",
    select: "Auswählen",
    clear: "Löschen",
    now: "Jetzt",
  },
  dsBasketCondition: {
    title: "Mindest-Warenkorb-Bedingungen",
    items: {
      NoConditions: "Keine Bedingungen",
      MinimumShopping: "Mindestbetrag im Warenkorb",
      MinimumProduct: "Mindestanzahl Produkte im Warenkorb",
      MaximumShopping: "Höchstbetrag im Warenkorb",
      MaximumProduct: "Höchstanzahl Produkte im Warenkorb",
    },
  },
  dsUserSettings: {
    title: "Mindest-Warenkorb-Bedingungen",
    groupTitle: "Benutzer, die",
    specialTitle: "Benutzer",
    labels: {
      minimumCart: "Mindest-Warenkorb-Bedingungen",
      users: "Benutzer",
    },
    items: {
      AllUser: "Alle Benutzer",
      group: "Benutzergruppe",
      special: "Spezielle Benutzer",
    },
    groupItems: {
      Order: "Bereits gekauft haben",
      noOrder: "Noch nicht gekauft haben",
    },
  },
  qrAddressUpdate: {
  title: "Adresse bearbeiten",
  labels: {
    address: "QR-Adresse",
  },
  hints: {
    allowedChars: "Nur englische Buchstaben, Zahlen, Bindestriche (-) und Unterstriche (_) sind erlaubt",
  },
  buttons: {
    removeInvalidChars: "Ungültige Zeichen entfernen",
  },
  errors: {
    minLength: "Mindestens 3 Zeichen sind erforderlich",
    invalidChars: "Ungültiges Zeichen! Verwenden Sie nur englische Buchstaben, Zahlen, - und _.",
    invalidAddress: "Die eingegebene Adresse ist ungültig",
    updateFailed: "Fehler beim Aktualisieren der Adresse",
  },
  successMessage: "Adresse erfolgreich aktualisiert",
  warning: "Warnung",
  warningMessage: "Durch das Ändern der Adresse funktionieren vorherige Links nicht mehr.",
  savePrompt: "Möchten Sie diese Änderung wirklich speichern?",
},
  dsFunctionType: {
    title: "Rabatt gilt für",
    productListTitle: "Produktliste",
    categoryListTitle: "Kategorieliste",
    labels: {
      applyDiscount: "Rabatt anwenden auf",
      category: "Kategorie",
    },
    items: {
      AllShoppingCart: "Gesamtbetrag des Warenkorbs",
      SpecialProducts: "Spezielle Produkte",
      SpecialCategories: "Spezielle Kategorien",
    },
  },
  dsLimitationUse: {
    title: "Nutzungsbeschränkung",
    discountCodeTitle: "Nutzungen des Codes",
    userTitle: "Nutzungen pro Benutzer",
    labels: {
      limitation: "Beschränkung",
      usage: "Nutzung",
      user: "Benutzer",
    },
    items: {
      NoLimitations: "Keine Beschränkungen",
      DiscountCode: "Nutzungen des Rabattcodes",
      User: "Nutzungen pro Benutzer",
    },
  },
  ManageHourLimitQr: {
    noLimit: "Keine Begrenzung",
    dateLimit: "Datumsbegrenzung",
    timeLimit: "Zeitbegrenzung",
    startDate: "Startdatum",
    endDate: "Enddatum",
    selectDate: "Datum auswählen",
    startTime: "Startzeit",
    endTime: "Endzeit",
  },
  discount_percent_range: "Rabatt muss zwischen 0 und 100 % liegen",
  discount_price_range: "Rabatt muss zwischen 0 und {max} liegen",
  invalid_number: "Nur Zahlen eingeben",
  min_order_cart: "Mindestbestellwert",
  preparation_time: "Zubereitungszeit (Minuten)",
  delivery_time: "Lieferzeit (Minuten)",
  max_product_in_order: "Max. Produkte pro Bestellung",
  max_order_by_person: "Max. Bestellungen pro Person",
  send_by_courier_price: "Kurierkosten",
  vat: "Steuersatz",
  send_by_post: "Postversandkosten",
  online_pay: "Online-Zahlung",
  pay_in_person_place: "Zahlung vor Ort",
  in_place: "Vor-Ort-Abholung",
  table_booking_ability: "Tischreservierung",
  send_by_courier: "Kurierlieferung",
  vat_switch: "Steuer",
  invalid_number: "Nur Zahlen eingeben",
  positive_number: "Zahl muss positiv sein",
  vat_range: "Steuersatz muss zwischen 0 und 100 % liegen",
  sort_column: "Sortierspalte",
  direction_sort: "Sortierrichtung",
  listFeedbackUser: {
    no_questions: "Du hast keine Fragen zur Feedback-Sammlung",
    add_feedback_prompt: "Neues Feedback im Reiter 'Hinzufügen' erstellen",
    question_label: "Frage",
    show_answers: "Antworten anzeigen",
    back_button: "Zurück",
    no_feedback: "Kein Feedback vorhanden!",
    user_opinion: "Meinung des Nutzers",
    score_label: "Bewertung",
  },
  manageDiscount: {
    createNewDiscount: "Neuen Rabattcode erstellen",
    copy: "Kopieren",
    row: "Zeile",
    id: "ID",
    discountCode: "Rabattcode",
    usageLimit: "Nutzungslimit",
    used: "Genutzt",
    manage: "Verwalten",
    edit: "Bearbeiten",
    delete: "Löschen",
    sendSms: "SMS an Zielgruppe senden",
    copySuccess: "Rabattcode kopiert",
    copyError: "Fehler beim Kopieren",
    deleteSuccess: "Rabattcode gelöscht",
    deleteError: "Fehler beim Löschen des Rabattcodes",
    smsSuccess: "Rabattcode an Zielgruppe gesendet",
    smsError: "Fehler beim Senden",
  },
  manageTableReservation: {
    table: "Tisch",
    number: "Tisch {num}",
    add_table: "Tisch hinzufügen",
    complete_info_for_customer:
      "Fülle die Infos aus, die dem Kunden angezeigt werden sollen",
    select_image: "Bild auswählen",
    table_name_number: "Tischname/-nummer",
    number_of_seats: "Anzahl Sitzplätze",
    type: "Typ",
    reservation_cost: "Reservierungskosten",
    enter_table_name: "Tischname/-nummer eingeben",
    table_type: "Tisch",
    couch_type: "Sofa",
    gazebo_type: "Pavillon",
  },
  create_menu: {
    data: {
      visitName_label: "Name des Besuchs",
      organizationName: "Große Fast-Food-Kette",
      subOrgan: "Probiere den besten Fast-Food-Geschmack mit uns",
      aboutUs:
        "Großes Fast-Food – mit Qualität und Respekt vor dem Kunden bieten wir das Beste.\nQualität ist unser Grundsatz.\nIm Fast-Food-Bereich haben wir mit unseren speziellen Sandwiches einen neuen Geschmack in die Welt der schnellen Mahlzeiten gebracht\nWir sind täglich bereit, euch bei Verwaltungsanlässen, Geburtstagen und mehr zu bedienen...",
      copyright: "Alle Rechte dieser Website gehören Terminal Advertising.",
      product: {
        title: "Produkte",
        pizzas: "Pizzen",
        pizza_roast_beef: "Pizza Roast Beef",
        pizza_roast_beef_desc: "🤩 Italienische Pizza mit Rindfleisch",
        pizza_roast_beef_ingredients:
          "Italienischer Pizzaboden 30 cm, 100 g Rinderhack, Pilze, Paprika, schwarze Oliven",
        pizza_chicken_mushroom: "Pizza Hähnchen & Pilze",
        pizza_chicken_mushroom_desc: "🍕 Klassisch 40 cm",
        pizza_chicken_mushroom_ingredients:
          "Frische Tomatensauce Pizzara, Käse (pasteurisiert), Hähnchenfilet, Pilze, Bergthymian",
        pizza_meat_mushroom: "Pizza Fleisch & Pilze",
        pizza_meat_mushroom_desc: "🥰 Pizza mit Rinderhack und Pilzen",
        pizza_meat_mushroom_ingredients:
          "Frische Tomatensauce Pizzara, Käse (pasteurisiert), Rinderoberschalen-Hack, Pilze, Bergthymian, für 2 Personen (29 cm) 355.000 Toman, für 1 Person (22 cm) 216.000 Toman",
        pizza_veggie: "Gemüsepizza",
        pizza_veggie_desc: "🍕 Amerikanische Gemüsepizza",
        pizza_veggie_ingredients:
          "Amerikanischer Pizzaboden, Mais, Pilze, Oliven, Tomaten, Zwiebeln, Paprika, Pizzakäse",
        pizza_special: "Spezialpizza",
        pizza_special_desc: "Amerikanische Spezialpizza",
        pizza_special_ingredients:
          "Amerikanischer Pizzaboden, gewürztes Rinderhack, Hamburger-Mischung Rind & Hähnchen 80 %, Mozzarella-Mischung, Speziaalsauce, Paprika, Pilze, ohne Sauce für 1 Person",
        pizza_bolognese: "Pizza Bolognese",
        pizza_bolognese_desc: "(Für 1 Person) Pizzaboden 23 cm 🤌",
        pizza_bolognese_ingredients:
          "Rinderhack, Mozzarella, Pilze, Paprika, Mais, schwarze Oliven in Scheiben",
        pizza_pepperoni: "Pizza Pepperoni",
        pizza_pepperoni_desc: "(Für 1 Person) Pizzaboden 23 cm",
        pizza_pepperoni_ingredients:
          "Italienischer Pizzaboden, Pepperoni 80 %, Marinara-Sauce, spezieller Pizzakäse",
        pizza_bacon: "Pizza Bacon",
        pizza_bacon_desc: "(Für 1 Person) Pizzaboden 23 cm 💥",
        pizza_bacon_ingredients:
          "Italienischer Pizzaboden, Marinara-Sauce, spezieller Pizzakäse, Bacon-Mischung Rind & Hähnchen 90 %, Pilze, Oliven, Paprika",
        pizza_mixed: "Gemischte Pizza",
        pizza_mixed_desc: "(Für 1 Person) Pizzaboden 23 cm 🤭",
        pizza_mixed_ingredients:
          "Hamburger-Mischung Rind & Hähnchen gehackt, Salami, Rinderhack, Pilze, Oliven, Paprika, Pizzakäse, Speziaalsauce",
        pizza_american_steak: "Amerikanische Steak-Pizza",
        pizza_american_steak_desc: "(Für 1 Person) 23 cm 💥",
        pizza_american_steak_ingredients:
          "Amerikanischer Pizzaboden, Rindfleischstücke, Pilze, Pizzakäse, Sesam",
        burgers: "Burger",
        cheeseburger: "Cheeseburger",
        cheeseburger_desc: "🤩 Mit Pommes",
        cheeseburger_ingredients:
          "2 Rindfleisch-Burger-Patties à 150 g, Speziaalsauce, Gouda-Käse, Essiggurke, Salat, Tomate",
        hamburger: "Hamburger",
        hamburger_desc: "😍 Reines Rindfleisch mit Speziaalsauce",
        hamburger_ingredients:
          "Rindfleisch-Burger-Patty 150 g, Essiggurke, Salat, Speziaalsauce, Tomate, Mac-Bun, Sauce für 1 Person",
        chicken_burger: "Chicken Burger",
        chicken_burger_desc: "Gegrilltes Hähnchen mit Käse",
        chicken_burger_ingredients:
          "150 g gegrillte Hähnchenbrust, Käse, Tomate, Essiggurke, Salat, Mac-Bun, Speziaalsauce",
        spice_burger: "Spicy Burger",
        spice_burger_desc: "Rindfleisch mit Spicy-Sauce",
        spice_burger_ingredients:
          "Rindfleisch-Burger-Patty 130 g, Spicy-Sauce, Salat, Tomate, Mac-Bun, spezielle Spicy-Sauce",
        double_burger: "Doppel-Burger",
        double_burger_desc: "Rindfleisch 150 g",
        double_burger_ingredients:
          "2 handgemachte Rindfleisch-Patties à 150 g, Pizzakäse, Karamellsauce, Salat, Rotkohl, weiße Speziaalsauce, rundes Brötchen",
        royal_burger: "Royal Burger",
        royal_burger_desc: "150 g Rindfleisch 🍔",
        royal_burger_ingredients:
          "Handgemachtes Rindfleisch-Patty 150 g, Pizzakäse, 5 Scheiben Salami, Karamellsauce, Salat, Rotkohl, weiße Speziaalsauce, rundes Brötchen",
        mushroom_burger: "Pilz-Burger",
        mushroom_burger_desc: "Rindfleisch 150 g",
        mushroom_burger_ingredients:
          "Handgemachtes Rindfleisch-Patty 150 g, Pilze, Karamellsauce, Salat, Rotkohl, weiße Speziaalsauce, rundes Brötchen, Mozzarella",
        mashroom_burger: "Mushroom Burger",
        mashroom_burger_desc: "100 % gegrilltes Rindfleisch 🤩",
        mashroom_burger_ingredients:
          "Handgemachtes 100 % gegrilltes Rindfleisch-Patty, Pommes, Tomate, Salat, Essiggurke, Pilzsauce, rundes Brötchen",
        fried_burger: "Frittierter Burger",
        fried_burger_desc: "100 % gegrilltes & frittiertes Rindfleisch 👌",
        fried_burger_ingredients:
          "Handgemachtes 100 % gegrilltes & frittiertes Rindfleisch-Patty, 150 g Pommes, Tomate, Salat, Essiggurke, Speziaalsauce, rundes Brötchen",
        fried: "Frittiert",
        fried_chicken: "Frittiertes Hähnchen",
        fried_chicken_desc: "😍 3 Stück frittiertes Hähnchen",
        fried_chicken_ingredients:
          "3 Stück frittiertes Hähnchen, 120–150 g Pommes, 100–120 g Krautsalat, Brotchen, Speziaalsauce",
        chicken_strips: "Chicken Strips",
        chicken_strips_desc:
          "4 Stück gewürztes scharfes Hähnchenfilet frittiert",
        chicken_strips_ingredients:
          "4 Stück frittiertes Hähnchenfilet, 120–150 g Pommes, 100–120 g Krautsalat, Brotchen, Tartarsauce",
        fried_filet: "Frittiertes Filet",
        fried_filet_desc: "🤩 2 Stück frittiertes Filet mit Speziaalsauce",
        fried_filet_ingredients:
          "2 Stück Strips, gegrillte Kartoffeln, Krautsalat, Brotchen, Knoblauchsauce, Thai-Chili-Sauce, Paprikasauce",
        fried_mushroom_onion: "Frittierte Pilze & Zwiebeln",
        fried_mushroom_onion_desc:
          "🤩 Frittierte Pilze & Zwiebeln mit Tartarsauce",
        fried_mushroom_onion_ingredients:
          "20 Stück frittierte Pilze, 6 Stück frittierte Zwiebelringe, Tartarsauce",
        fried_wings: "Frittierte Flügel",
        fried_wings_desc: "6 Stück frittierte Flügel 🍗",
        fried_wings_ingredients: "Sechs gegrillte & frittierte Flügel",
        fried_chicken_basket: "Frittierter Hähnchen-Korb",
        fried_chicken_basket_desc: "(Für 2 Personen) 😍",
        fried_chicken_basket_ingredients:
          "2 Stück frittiertes Hähnchen, 2 Stück Strips, 2 Stück Zwiebelringe, 2 Stück Garnelen-Nuggets frittiert, 2 Stück Hähnchen-Nuggets",
        fried_schnitzel: "Frittiertes Schnitzel",
        fried_schnitzel_desc: "Vier Stück Hähnchenschnitzel 💥",
        fried_schnitzel_ingredients:
          "Vier gegrillte & frittierte gewürzte Hähnchenschnitzel",
        veggie_basket_fried: "Frittierter Gemüsekorb",
        veggie_basket_fried_desc: "250 g 🤩",
        veggie_basket_fried_ingredients:
          "250 g, frittierte Zucchini, Aubergine, Pilze, Kartoffeln",
        fried_chicken_2_piece: "Frittiertes Hähnchen 2 Stück",
        fried_chicken_2_piece_desc: "2 Stück frittiertes Hähnchen 🍗",
        fried_chicken_2_piece_ingredients:
          "120–150 g Pommes, 100–120 g Krautsalat, Brotchen, Speziaalsauce",
        fried_chicken_5_piece: "Frittiertes Hähnchen 5 Stück",
        fried_chicken_5_piece_desc: "Fünf Stück frittiertes Hähnchen",
        fried_chicken_5_piece_ingredients:
          "150–200 g Pommes, zwei Krautsalate 100–120 g, zwei Brotchen, Speziaalsauce",
        fried_chicken_7_piece: "Frittiertes Hähnchen 7 Stück",
        fried_chicken_7_piece_desc: "Sieben Stück frittiertes Hähnchen 💥",
        fried_chicken_7_piece_ingredients:
          "150–200 g Pommes, Krautsalat 100–120 g, 3 Brotchen, Speziaalsauce, Sauce für 1 Person frittiert",
        sandwich: "Sandwich",
        hotdog_sandwich: "Hotdog-Sandwich",
        hotdog_sandwich_desc: "Hotdog-Sandwich mit Pilzen und Käse",
        hotdog_sandwich_ingredients:
          "Gegrillte Hotdog-Wurst, Salat, Tomate, Essiggurke, Pilze und Pizzakäse",
        roast_beef_sandwich: "Roast Beef Sandwich",
        roast_beef_sandwich_desc: "✔️ Rinderhack",
        roast_beef_sandwich_ingredients:
          "Rindfleisch, Pizzakäse, Pilze, Kartoffelchips in Scheiben, Salat, Tomate, Essiggurke, Speziaalsauce, französisches Brot",
        ham_sandwich: "Schinken-Sandwich",
        ham_sandwich_desc: "Hähnchen-Schinken-Sandwich mit Pilzen (kalt)",
        ham_sandwich_ingredients:
          "Hähnchen-Schinken mit Pilzen, Salat, Tomate, Essiggurke, Kartoffelchips in Scheiben, Speziaalsauce, Baguette",
        bandari_sausage_sandwich: "Bandari-Wurst-Sandwich",
        bandari_sausage_sandwich_desc: "💥 Scharfes Bandari-Sandwich",
        bandari_sausage_sandwich_ingredients:
          "Bandari-Essen mit geräucherter Cocktailwurst 55 %, Tomate, Essiggurke, Speziaalsauce, Zwiebel und Koriander, Bulki-Brot",
        tongue_mushroom_sandwich: "Zunge & Pilze Sandwich",
        tongue_mushroom_sandwich_desc: "150 g Rinderzunge",
        tongue_mushroom_sandwich_ingredients:
          "Pilze, pasteurisierter Pizzakäse, Oliven, Mais, Salat, Essiggurke, Tomate, Sauce, Beilagen, Pommes, Krautsalat",
        falafel_sandwich: "Falafel-Sandwich",
        falafel_sandwich_desc: "Sechs Stück Falafel 🌭",
        falafel_sandwich_ingredients:
          "Sechs Stück Falafel, Essiggurke, Tomate, Salat, Sauce für 1 Person, Beilagen, Pommes, Krautsalat",
        cheesy_kebab_turki_sandwich: "Käse-Türkischer-Kebab-Sandwich",
        cheesy_kebab_turki_sandwich_desc: "150 g Rindfleisch",
        cheesy_kebab_turki_sandwich_ingredients:
          "150 g Rindfleisch, spezieller Pizzakäse, Essiggurke, Tomate, Salat, Sauce für 1 Person, Pommes, Krautsalat",
        roast_chicken_sandwich: "Gegrilltes Hähnchen-Sandwich",
        roast_chicken_sandwich_desc: "Hähnchenschnitzel und Pilze 🤩",
        roast_chicken_sandwich_ingredients:
          "Hähnchenschnitzel und Pilze, spezieller Pizzakäse, Oliven, Mais, Sesam, Salat, Paprika, Essiggurke, Tomate, Speziaalsauce, Beilagen, Pommes",
        cheesy_indian_sandwich: "Indisches Käse-Sandwich",
        cheesy_indian_sandwich_desc: "Deutsche Wurst 💥",
        cheesy_indian_sandwich_ingredients:
          "Deutsche Käsewurst, Mais, Salat, Pilze, Speziaalsauce, Beilagen, Pommes, Krautsalat",
        snack: "Snack",
        chicken_snack: "Hähnchen-Snack",
        chicken_snack_desc: "😋 Gehackte Hähnchenbrust",
        chicken_snack_ingredients:
          "150 g Hähnchenbrust, Paprika, Pilze, spezielles Snack-Brot, Speziaalsauce",
        meat_snack: "Fleisch-Snack",
        meat_snack_desc: "🥪 Doppelter Fleisch-Snack",
        meat_snack_ingredients:
          "Doppelt, Rinderoberschalen-Hack, Mozzarella, Mais, Paprika, Speziaalsauce, Toastbrot",
        chicken_meat_snack: "Chicken-Meat-Snack",
        chicken_meat_snack_desc: "🤩 Doppelter Chicken-Meat-Snack",
        chicken_meat_snack_ingredients:
          "Doppelt, gehackte Hähnchenbrust, Rinderoberschalen-Hack, Mozzarella, Mais, Paprika, Speziaalsauce, Toastbrot",
        special_snack: "Spezial-Snack",
        special_snack_desc: "🤤 Doppelter Spezial-Snack",
        special_snack_ingredients:
          "Doppelt, Kalabas-Mischung Rind & Hähnchen 90 %, Mozzarella, Mais, Paprika, Speziaalsauce, Toastbrot",
        roast_beef_snack: "Roast Beef Snack",
        roast_beef_snack_desc: "Rinderhack 🍖",
        roast_beef_snack_ingredients:
          "Rinderhack, Pilze, Pizzakäse, Paprika, Mais, Beilagen, Pommes, Krautsalat",
        veggie_snack: "Gemüse-Snack",
        veggie_snack_desc: "4 Stück Gemüse-Snack",
        veggie_snack_ingredients:
          "Brokkoli, Mais, Oliven, Diät-Pizzakäse, Pilze, Beilagen, Pommes, Krautsalat",
        chicken_mushroom_snack: "Hähnchen & Pilze Snack",
        chicken_mushroom_snack_desc: "Hähnchenschnitzel und Pilze 👌",
        chicken_mushroom_snack_ingredients:
          "Hähnchenschnitzel, Pilze, spezieller Pizzakäse, Oliven, Mais, Paprika, Beilagen, Pommes, Krautsalat",
        pepperoni_snack: "Pepperoni-Snack",
        pepperoni_snack_desc: "Kalabas Pepperoni 90 % 💥",
        pepperoni_snack_ingredients:
          "Doppelt, Kalabas Pepperoni 90 %, Mozzarella, Mais, Paprika, Speziaalsauce",
        bologna_snack: "Bologna-Snack",
        bologna_snack_desc: "Rinderhack 👌",
        bologna_snack_ingredients:
          "Doppelt, Rinderhack, spezieller Bacon, gebleichte Pilze, Mais, Mozzarella, Paprika, Speziaalsauce",
        pasta: "Pasta",
        alfredo_pasta: "Alfredo-Pasta",
        alfredo_pasta_desc: "Alfredo-Pasta mit spezieller Pilzsauce",
        alfredo_pasta_ingredients: "350 g Penne",
        macaroni: "Makkaroni",
        macaroni_desc: "🥣 Makkaroni mit Fleisch und Pilzen",
        macaroni_ingredients:
          "Bandnudeln 1,2, 100 g Rinderhack, Pilze, Paprika, gewürfelte gegrillte Kartoffeln, Erbsen",
        spaghetti_bolognese: "Spaghetti Bolognese",
        spaghetti_bolognese_desc: "🥰 Linguine-Pasta",
        spaghetti_ingredients:
          "700 g, Linguine-Pasta, Rind- und Lammhack, Bolognese-Sauce, spezielle rote Rasu-Sauce, Plastiklöffel und -gabel nach Wahl",
        chicken_stroganoff: "Hähnchen Stroganoff",
        chicken_stroganoff_desc:
          "😍 Hähnchen Stroganoff mit Hähnchenbruststücken",
        chicken_stroganoff_ingredients:
          "180 g gewürzte Hähnchenbruststücke, Sahne, gebleichte Pilze, Parmesan, handgeschnittene Pommes, spezieller Mikrowellenbehälter",
        penne_arrabbiata: "Penne Arrabbiata",
        penne_arrabbiata_desc: "Hähnchenbrust 💥",
        penne_arrabbiata_ingredients:
          "Für 1 Person, Hähnchenbrust, Pasta, Pilze, Parmesan, Kirschtomaten, Petersilie, Arrabbiata-Sauce",
        chicken_pesto_pasta: "Hähnchen-Pesto-Pasta",
        chicken_pesto_pasta_desc: "(Für 1 Person) Hähnchenbrust",
        chicken_pesto_pasta_ingredients:
          "Hähnchenbrust, Pilze, Parmesan, Kirschtomaten, Petersilie, Arrabbiata-Sauce",
        carbonara_pasta: "Carbonara-Pasta",
        carbonara_pasta_desc: "Rindfleisch-Bacon 97 %",
        carbonara_pasta_ingredients:
          "Pasta, Rindfleisch-Bacon 97 %, Alfredo-Sauce, Parmesan, Kirschtomaten, Petersilie",
        appetizer: "Vorspeisen",
        hot_chips: "Hot Chips",
        hot_chips_desc: "😙 Verschiedene Chips-Sorten",
        hot_chips_ingredients:
          "Kilo Chips, Speziaalsauce, Hähnchen-Schinken 70 %, Pilze, Paprika, Pizzakäse, Gouda",
        lasagna: "Lasagne",
        lasagna_desc: "Lasagne mit Rinderhack",
        lasagna_ingredients:
          "3 Lasagne-Blätter, Rinderhack, Pilze, Paprika, schwarze Oliven, Pizzakäse, Speziaalsauce",
        french_fries: "Pommes frites",
        french_fries_desc: "Pommes frites mit spezieller Soße",
        french_fries_ingredients: "150 g Pommes frites, spezielle Soße",
        baked_potato: "Ofenkartoffel",
        baked_potato_desc: "🍟 Ofenkartoffel mit Rinderspeck",
        baked_potato_ingredients:
          "150 g Pommes frites, Rinderspeck 90 %, Pizzakäse, spezielle Gewürze, Einzelportionssoße",
        garlic_bread: "Knoblauchbrot",
        garlic_bread_desc: "Spezielle Knoblauchsoße💥",
        garlic_bread_ingredients:
          "Amerikanischer Pizzateig, gemischter Pizzakäse, spezielle Knoblauchsoße, Sesam",
        silo_potatoes: "Silo-Kartoffeln",
        silo_potatoes_desc: "Pommes frites für zwei Personen",
        silo_potatoes_ingredients:
          "Silo-gewürzte Pommes frites, Rinderspeck 97 %, Cheddar-Soße, Aioli, Frühlingszwiebeln, Petersilie",
        bbq_sausage: "BBQ-Würstchen",
        bbq_sausage_desc: "Marinierte Fingerwürstchen🍢",
        bbq_sausage_ingredients:
          "500 g gewürztes Kartoffelpüree, 200 g marinierte Fingerwürstchen, Zwiebelringe, grüne Oliven, Parmesanpulver, Kirschtomaten, Mikrogrün, Grillkäse, BBQ-Soße, scharf",
        silo_toast: "Silo-Toast",
        silo_toast_desc: "160 g Rinderfilet-Scheiben🤩",
        silo_toast_ingredients:
          "160 g Rinderfilet-Scheiben, französischer Salat, Rinderspeck, Bauernbrot, BBQ-Soße, Tartar-Soße, Sauerampfer, grüne Oliven, Mikrogrün, Aioli, Parmesanpulver",
        salad_and_dessert: "Salat und Dessert",
        caesar_salad: "Caesar-Salat",
        caesar_salad_desc: "Einzelportion Caesar-Salat🥗",
        caesar_salad_ingredients:
          "Salatmischung, gegrilltes Hähnchen, Parmesan, Croutons (Knoblauchbrot), Caesar-Dressing, Oliven",
        caesar_salad_extra: "Romanasalat, Croutons, Parmesan",
        coleslaw_salad: "Coleslaw",
        coleslaw_salad_desc: "Einzelportion Coleslaw🍴",
        coleslaw_salad_ingredients:
          "Hausgemacht, Einzelportion, Weißkohl, Mais, Soße",
        macaroni_salad: "Nudelsalat",
        macaroni_salad_desc: "Nudelsalat mit hausgemachtem Schinken",
        macaroni_salad_ingredients: "Nudeln, hausgemachter Schinken",
        pachira_salad: "Pachira-Salat",
        pachira_salad_desc: "Pachira-Salat für zwei Personen🥗",
        pachira_salad_ingredients:
          "Für zwei, Salatmischung, Rinderspeck-Chips 98 %, karamellisierte Walnüsse, Parmesan, Erdbeeren, pflanzlicher Kaviar, Rosinen, Zitronenscheiben, Rosenbeeren-Soße",
        greek_salad: "Griechischer Salat",
        greek_salad_desc:
          "Traditioneller griechischer Salat mit Feta und Oliven",
        greek_salad_ingredients: "Feta, Oliven, Gurke",
        tiramisu: "Tiramisu",
        tiramisu_desc: "Klassisches italienisches Tiramisu-Dessert",
        tiramisu_ingredients: "Kaffee, Mascarpone, Kakao",
        beverages: "Getränke",
        local_yogurt_drink: "Lokales Joghurtgetränk",
        local_yogurt_drink_desc: "Familienartiges lokales Joghurtgetränk🥛",
        local_yogurt_drink_ingredients: "",
        black_soda: "Schwarze Limonade",
        black_soda_desc: "Glas schwarze Limonade🧋",
        black_soda_ingredients: "",
        fanta: "Gelbe Limonade",
        fanta_desc: "Glas gelbe Limonade🥤",
        fanta_ingredients: "",
        mojito: "Mojito",
        mojito_desc: "Glas Mojito, 350 bis 400 ml🍸",
        mojito_ingredients: "",
        tropical_malt_beverage: "Tropisches Malzgetränk",
        tropical_malt_beverage_desc: "Glas tropisches Malzgetränk🍺",
        tropical_malt_beverage_ingredients: "",
      },
      socialMedia: {
        address_label: "Adresse",
        address_text: "Geben Sie den Link zur gewünschten Website ein",
        instagram_label: "Instagram",
        instagram_text: "Geben Sie Ihren Benutzernamen ein",
        whatsapp_label: "WhatsApp",
        whatsapp_text: "+989123456789",
      },
      videoGallery: {
        title: "Videogalerie",
        description:
          "Um mehr über die Dienste des intelligenten QR-Land-Systems zu erfahren, schauen Sie sich die folgenden Videos an.",
        tutorial: "Tutorial",
        fast_food: "Fast Food",
      },
      feedback: {
        title: "Ihr Feedback",
        description:
          "Bitte beantworten Sie die folgenden Fragen, um uns bei der Verbesserung unserer Dienste zu helfen",
        question1:
          "Wie zufrieden sind Sie mit unseren Dienstleistungen und der Lebensmittelqualität?",
        question2: "Wie bewerten Sie die Vielfalt der Gerichte im Restaurant?",
        question3: "Wie bewerten Sie das Verhalten des Restaurantpersonals?",
        question4: "Wurde das Essen pünktlich geliefert?",
        question5:
          "Haben Sie Vorschläge zur Verbesserung unserer Dienstleistungen oder der Lebensmittelqualität?",
      },
      worksheet: {
        saturday: "Samstag",
        sunday: "Sonntag",
        monday: "Montag",
        tuesday: "Dienstag",
        wednesday: "Mittwoch",
        thursday: "Donnerstag",
        friday: "Freitag",
        shift_1_saturday: "10:00 bis 22:00",
        shift_1_sunday: "10:00 bis 22:00",
        shift_1_monday: "10:00 bis 22:00",
        shift_1_tuesday: "10:00 bis 22:00",
        shift_1_wednesday: "10:00 bis 00:00",
        shift_1_thursday: "10:00 bis 00:00",
        shift_1_friday: "10:00 bis 00:00",
      },
      gallery: {
        gallery_0: "Galerie 0",
        image_1: "1",
        image_2: "2",
        image_3: "3",
        image_4: "4",
        image_5: "5",
        baked_potato_2: "Ofenkartoffel 2",
        chicken_stroganoff_1: "Hähnchen Stroganoff 1",
      },
      contact: {
        phone_1: "09999903535",
        phone_2: "02191017077",
        phone_3: "90007425",
        company_number: "02191017077",
        email: "info@qrland.ir",
        fax: "02191016066",
        location:
          "Teheran, Shariati-Straße, nach der Seyed-Khandan-Brücke, Khandan-Sackgasse, Nr. 6, Einheit 3",
        codePostal: "1541946815",
        website: "www.terminalads.com",
        address_details:
          "Iran, Teheran, Stadt Teheran, Teheran, Stadtbezirk 3 Teheran, Seyed-Khandan-Viertel, Dr. Ali Shariati, Khandan",
      },
    },
    messages: {
      qr_created_success: "Online-Menü erfolgreich erstellt.",
      qr_updated_success: "Ihr Online-Menü-QR wurde erfolgreich bearbeitet.",
      qr_create_error: "Fehler beim Erstellen des QR!",
      qr_update_error: "Fehler beim Speichern/Bearbeiten des QR",
      template_categories_saved:
        "Beispielmodell-Kategorien wurden erfolgreich gespeichert.",
      template_products_saved:
        "Beispielmodell-Produkte wurden erfolgreich gespeichert.",
      template_categories_error:
        "Fehler beim Speichern der Beispielmodell-Kategorien!",
      template_products_error:
        "Fehler beim Speichern der Beispielmodell-Produkte!",
    },
    sample_menu: "Beispielmenü",
    view_qr: "QR anzeigen",
    preview: "Vorschau",
    download_qr: "QR herunterladen",
    create_qr: "QR erstellen",
    online_menu_name: "Name des Online-Menüs",
    online_menu_name_short: "Menüname",
    enter_qr_address: "QR-Adresse eingeben",
    qr_address: "QR-Adresse",
    enter_menu_information: "Menüinformationen eingeben",
    cleardefaults: "Standardeinstellungen löschen",
    select_sample_menu: "Beispielmenü auswählen",
    select_ready_menu: "Fertigmenü auswählen",
    online_sales: "Online-Verkauf",
    sales_settings: "Verkaufseinstellungen",
    download: "Herunterladen",
    gallery_photos: "Galeriefotos",
    fast_food_1: "Fast-Food-Bild 1",
    fast_food_2: "Fast-Food-Bild 2",
    large_chain_fast_food: "Große Fast-Food-Kette",
    best_fast_food_taste_experience:
      "Erleben Sie den besten Fast-Food-Geschmack mit uns",
    online_menu_created_successfully: "Online-Menü erfolgreich erstellt.",
    qr_creation_failed: "Fehler beim Erstellen des QR!",
    online_menu_qr_updated_successfully:
      "Ihr Online-Menü-QR wurde erfolgreich bearbeitet.",
    error_saving_updating_qr: "Fehler beim Speichern/Bearbeiten des QR",
    sample_model_categories_saved_successfully:
      "Beispielmodell-Kategorien wurden erfolgreich gespeichert.",
    sample_model_products_saved_successfully:
      "Beispielmodell-Produkte wurden erfolgreich gespeichert.",
    error_saving_sample_model_products:
      "Fehler beim Speichern der Beispielmodell-Produkte!",
    error_saving_sample_model_categories:
      "Fehler beim Speichern der Beispielmodell-Kategorien!",
  },
  editMenu: {
    enter_menu_information: "Menüinformationen eingeben",
    online_menu_name: "Name des Online-Menüs",
    online_menu_name_short: "Kurzname des Online-Menüs",
    fields: {
      qr_address_hint: "QR-Adresse für den Zugriff auf das Online-Menü",
    },
    online_sales: "Online-Verkauf",
    sales_settings: "Verkaufseinstellungen",
    shop: {
      upload_banner: "Banner hochladen",
      create_product: "Produkt erstellen",
      user_info: "Benutzerinformationen",
      add_social_media: "Soziale Medien hinzufügen",
      photo_gallery: "Fotogalerie",
      video_gallery: "Videogalerie",
      feedback: "Feedback",
      working_hours: "Öffnungszeiten",
    },
    success_message: "Ihre Visitenkarte wurde erfolgreich bearbeitet.",
  },
  qrCodeSquare: {
    dots_color: "Punktefarbe",
    gradient_color: "Verlaufsfarbe",
    linear: "Linear",
    radial: "Radial",
    color_rotation: "Farbdrehung",
    first_color: "Erste Farbe",
    second_color: "Zweite Farbe",
    dots_color_label: "Punktefarbe",
  },
  language: {
    selectAll: "Alle auswählen",
    lang: {
      fa: "Persisch",
      ar: "Arabisch",
      ar_ae: "Arabisch (VAE)",
      ar_iq: "Arabisch (Irak)",
      en_US: "Englisch (USA)",
      en_GB: "Englisch (UK)",
      de: "Deutsch",
      fr: "Französisch",
      zh_CN: "Vereinfachtes Chinesisch",
      zh_TW: "Traditionelles Chinesisch",
      tr: "Türkisch",
      ru: "Russisch",
      hy: "Armenisch",
    },
    only_manual_now: "Derzeit ist nur manuelle Übersetzung möglich",
    ai_coming_soon: "KI-Übersetzung wird bald aktiviert",
    got_it: "Verstanden",
    origin_language: "Ausgangssprache",
    target_languages: "Zielsprachen",
    remove_all: "Alle Sprachen entfernen",
    translation_method: "Übersetzungsmethode wählen",
    manual_translation: "Manuelle Übersetzung",
    ai_translation: "KI-Übersetzung",
    coming_soon: "Demnächst",
    source_language_updated: "Ausgangssprache aktualisiert",
    error_changing_source_language: "Fehler beim Ändern der Ausgangssprache",
    source_language_created: "Neue Ausgangssprache erstellt",
    languages_saved: "Neue Sprachen gespeichert",
    error_saving_languages: "Fehler beim Speichern der Sprachen",
    error_loading_language: "Fehler beim Laden der Sprache",
    languages_removed: "Entfernte Sprachen",
    new_languages_to_save: "Neue Sprachen zum Speichern",
    saved: "Gespeichert",
    management_langs: "Sprachverwaltung",
    add_langs: "Sprache hinzufügen",
    change_language: "Sprache ändern",
    visit_card: "Visitenkarte",
    translate_to: "Übersetzen nach",
    main_language: "Hauptsprache",
    no_languages_available: "Keine Sprachen verfügbar",
    return_to_default: "Zurück zur Standardsprache",
    translate: "Übersetzen",
    changes_pending: "Warten auf das Anwenden der Änderungen",
    apply_changes: "das Anwenden der Änderungen",
    cancel_changes: "Abbrechen",
  },
  winner_list: "Gewinnerliste",
  qrwinnersList: {
    winnerstotalcount: "Gesamtzahl der Gewinner für QR",
    winnerscountoffilter: "Anzahl der Gewinner mit angewendetem Filter",
    winnersList: "QR-Gewinnerliste",
    prize: "Preis",
    winnerName: "Name des Gewinners",
    date: "Datum",
    noWinners: "Keine Gewinner vorhanden",
    perPage: "Einträge pro Seite",
    search: "Suche nach Gewinner oder Preis",
    sortDirection: "Sortierrichtung",
    sortBy: "Sortieren nach",
  },
  appearance_settings: "Aussehen-Einstellungen",
  header_color: "Header-Farbe",
  background_color: "Hintergrundfarbe",
  text_color: "Textfarbe",
  font_size: "Schriftgröße",
  chat_logo: "Chat-Logo",
  floating_button_icon: "Schwebende Schaltfläche Icon",
  assistant_name: "Assistentenname",
  chat_preview: "Chat-Vorschau",
  smart_assistant: "Intelligenter Assistent",
  online: "Online",
  aiChatSettings: {
    select_assistant: "Assistent auswählen",
    appearance_settings: "Design-Einstellungen",
    lead_connection_tab: "Lead-Erfassung - Verbindung zum Kundenclub",

    header_settings: "Header-Einstellungen",
    header_settings_desc: "Farbe und Stil des Chat-Headers",
    text_settings: "Text-Einstellungen",
    text_settings_desc: "Schriftfarbe und -größe",
    logo_settings: "Logo-Einstellungen",
    logo_settings_desc: "Foto oder Icon des Assistenten",
    background_settings: "Hintergrund-Einstellungen",
    background_settings_desc: "Hintergrundbild oder -farbe",

    gradient_color: "Farbverlauf",
    solid_color: "Einfarbig",
    use_image: "Bild verwenden",
    use_icon: "Icon verwenden",

    first_color: "Erste Farbe",
    second_color: "Zweite Farbe",
    header_color: "Header-Farbe",
    text_color: "Textfarbe",
    background_color: "Hintergrundfarbe",

    font_size: "Schriftgröße",

    robot: "Roboter",
    chat: "Chat",
    support: "Support",
    question: "Frage",
    message: "Nachricht",
    assistant_voice: "Assistent",
    ai_brain: "Künstliche Intelligenz",

    lead_connection_title: "Verbindung zum Kundenclub",
    lead_alert:
      "Diese Einstellungen bewirken, dass die Informationen des Benutzers im Kundenclub gespeichert werden, wenn er einen Lead sendet.",

    hasAssistantsName_label: "Namen erfassen",
    hasAssistantsName_hint: "Namen des Benutzers abfragen",
    hasAssistantsFamily_label: "Nachnamen erfassen",
    hasAssistantsFamily_hint: "Nachnamen des Benutzers abfragen",
    hasAssistantsMobile_label: "Mobilnummer erfassen",
    hasAssistantsMobile_hint: "Mobilnummer des Benutzers abfragen",
  },
  assistantChatViewer: {
    assistant_name: "Intelligenter Assistent",
    online: "Online",
    new_chat: "Neuer Chat",
    clear_chat: "Chat löschen",
    close: "Schließen",
    message_placeholder: "Nachricht...",
    processing: "Wird verarbeitet...",
    renew: "Verlängern",
    created_at: "Erstellt am",
    last_edit: "Zuletzt bearbeitet",
    copied: "Kopiert",
    copy: "Kopieren",
    print_qr: "QR drucken",
    print_visit_card: "Visitenkarte drucken",
    send_link: "Link senden",
    winner_list: "Gewinnerliste",
    customer_list: "Kundenliste",
    order_list: "Bestellliste",
    reserved_appointments: "Reservierte Termine",
    feedback: "Feedback",
    request_form: "Anfrageformular",
    transfer_ownership: "Eigentum übertragen",
    store_management: "Shop-Verwaltung",
    select_nfc_card: "NFC-Karte auswählen",
    edit: "Bearbeiten",
    design: "Design",
    qr_settings: "QR-Einstellungen",
    deactivate: "Deaktivieren",
    download: "Herunterladen",
    viewed: "Mal angesehen",
    see_more: "Mehr anzeigen",
    updating_qr: "QR wird aktualisiert...",
  },
  create_game: "Spiel erstellen",
  ready_games: "Fertige Spiele",
  add_game: "Spiel hinzufügen",
  game_gallery: "Spiel-Galerie",
  game_size_error: "Dateigröße des Spiels darf 2 MB nicht überschreiten",
  game_upload_error: "Fehler beim Hochladen des Spiels",
  no_game_available: "Keine Spiele verfügbar",
  to_use_ready_games_search_category_or_product:
    "Um fertige Spiele zu verwenden, nach Kategorie oder Produkt suchen",
  gif_size_error: "Dateigröße des GIF darf 2 MB nicht überschreiten",
  previewer_page: "Vorschau-Anzeige",
  // ─────────────────────────────────────────────────────
  // Übersetzungsschlüssel für Spiel, GIF und Einstellungen
  // Datei: src/core/services/langs/de.js
  // Sprache: Deutsch (Standard)
  // ─────────────────────────────────────────────────────
  // 1. Haupt-Spiel-Editor (PublicGameEditor)
  game_editor: "Spieleditor",
  reset_defaults: "Auf Standard zurücksetzen",
  save_and_preview: "Speichern und Vorschau",
  texts: "Texte",
  images: "Bilder",
  colors: "Farben",
  general_settings: "Allgemeine Einstellungen",
  gameplay_settings: "Gameplay-Einstellungen",
  effects: "Effekte",
  login_and_phone: "Login und Telefonnummer",
  no_settings_available_for_this_game_type:
    "Für diesen Spieltyp sind keine Einstellungen verfügbar",
  confirm_reset: "Zurücksetzen bestätigen",
  reset_all_settings_to_default:
    "Sind Sie sicher, dass Sie alle Einstellungen auf Standard zurücksetzen möchten?",
  yes_reset: "Ja, zurücksetzen",
  cancel: "Abbrechen",
  settings_reset_successfully: "Einstellungen erfolgreich zurückgesetzt",
  saved_and_ready_for_preview: "Gespeichert und bereit für Vorschau",

  // 2. Login & Telefon-Tab (TabLogin)
  login_and_phone_settings: "Login- und Telefon-Einstellungen",
  ask_phone_after_game: "Telefonnummer nach Spielende abfragen",
  phone_prompt_text: "Text für Telefonnummer-Abfrage",
  phone_prompt_hint: "Der Text, der im Telefonnummer-Dialog angezeigt wird",
  submit_button: "Absenden-Button",
  login_dialog_logo: "Login-Dialog-Logo",
  logo_url: "Logo-URL",

  // 3. Effekte-Tab (TabEffect)
  game_effects_settings: "Spieleffekt-Einstellungen",
  sound_enabled: "Sound aktivieren",
  volume: "Lautstärke",
  volume_hint: "Lautstärke des Spiels (0 bis 1)",
  oscillator_type: "Oszillator-Typ",
  jump_sound_freq: "Sprung-Sound-Frequenz",
  hit_sound_freq: "Treffer-Sound-Frequenz",
  powerup_sound_freq: "Power-up-Sound-Frequenz",
  move_sound_freq: "Bewegungs-Sound-Frequenz",
  combo_base_freq: "Combo-Basis-Frequenz",
  sound_durations: "Sound-Dauern",
  move_duration_ms: "Bewegungs-Sound-Dauer (ms)",
  jump_duration_ms: "Sprung-Sound-Dauer (ms)",
  combo_duration_ms: "Combo-Sound-Dauer (ms)",
  hit_duration_ms: "Treffer-Sound-Dauer (ms)",
  vibration_enabled: "Vibration aktivieren",
  particles_enabled: "Partikel aktivieren",
  explosion_settings: "Explosion-Partikel-Einstellungen",
  particle_count: "Partikel-Anzahl",
  gravity: "Schwerkraft",
  friction: "Reibung",
  fade_speed: "Ausblend-Geschwindigkeit",

  // 4. Bilder-Tab (TabImages)
  game_images_and_assets: "Spielbilder & Assets",
  player_image: "Spieler-Bild",
  player: "Spieler",
  powerup_image: "Power-up-Bild",
  qr_powerup: "QR-Power-up",
  enemy_images: "Gegner-Bilder",
  optional_multi: "Optional, mehrere Bilder",
  enemies: "Gegner",
  background_image: "Hintergrund-Bild",
  background: "Hintergrund",
  phone_frame_background: "Telefonrahmen-Hintergrund",
  phone_frame: "Telefonrahmen",
  winner_background: "Gewinner-Hintergrund",
  winner: "Gewinner",
  ground_image: "Boden-Bild",
  ground: "Boden",
  player_character: "Spieler-Charakter",
  far_background_layer: "Ferner Hintergrund-Layer",
  background_far: "Ferner Hintergrund",
  near_background_layer: "Naher Hintergrund-Layer",
  background_near: "Naher Hintergrund",
  obstacle_images: "Hindernis-Bilder",
  multi_optional: "Mehrere Bilder, optional",
  obstacles: "Hindernisse",

  // 5. Texte-Tab (TabTexts)
  game_text_contents: "Spiel-Textinhalte",
  main_screen_texts: "Hauptbildschirm-Texte",
  game_title: "Spieltitel",
  game_subtitle: "Untertitel des Spiels",
  start_button: "Start-Button",
  score_label: "Punkte-Anzeige",
  game_over_screen: "Game-Over-Bildschirm",
  game_over_title: "Game-Over-Titel",
  game_over_subtitle: "Game-Over-Untertitel",
  phone_prompt: "Telefonnummer-Abfrage",
  restart_button: "Neustart-Button",
  hud_and_labels: "HUD & Beschriftungen",
  level_label: "Level-Anzeige",
  combo_label: "Combo-Anzeige",
  final_score_label: "Endpunkte-Anzeige",
  high_score_label: "Highscore-Anzeige",
  messages_and_popups: "Nachrichten & Popups",
  new_record_message: "Neuer Rekord-Nachricht",
  fun_random_messages: "Lustige Zufallsnachrichten",
  add_new_message: "Neue Nachricht hinzufügen",

  // 6. Allgemeine Einstellungen-Tab (TabSetting)
  general_game_settings: "Allgemeine Spieleinstellungen",
  enemy_spawn_rate: "Gegner-Spawn-Rate",
  frames_between_enemies_spawn: "Frames zwischen Gegner-Spawns",
  powerup_spawn_rate: "Power-up-Spawn-Rate",
  frames_between_qr_spawn: "Frames zwischen QR-Spawns",
  win_score_threshold: "Sieg-Punkte-Schwelle",
  score_required_for_win_or_phone_prompt:
    "Benötigte Punkte für Sieg oder Telefon-Abfrage",
  starting_lives: "Start-Leben",
  high_score_storage_key: "Highscore-Speicher-Schlüssel",
  phone_prompt_score_threshold: "Punkte-Schwelle für Telefon-Abfrage",
  score_to_show_phone_number_form: "Punkte zum Anzeigen des Telefon-Formulars",
  no_general_settings_available_for_this_game:
    "Keine allgemeinen Einstellungen für dieses Spiel verfügbar",

  // 7. Gameplay-Tab (TabGamePlay)
  speed_settings: "Geschwindigkeits-Einstellungen",
  initial_speed: "Start-Geschwindigkeit",
  max_speed: "Maximale Geschwindigkeit",
  speed_increase_every_frames: "Geschwindigkeit erhöhen alle X Frames",
  speed_increase_amount: "Geschwindigkeits-Erhöhungsbetrag",
  distance_per_level: "Distanz pro Level",
  level_speed_increase: "Geschwindigkeits-Erhöhung pro Level",
  jump_and_physics: "Sprung & Physik",
  jump_force: "Sprungkraft",
  max_jump_height: "Maximale Sprunghöhe",
  lanes_settings: "Spur-Einstellungen",
  number_of_lanes: "Anzahl der Spuren",
  starting_lane: "Start-Spur",
  enemies_spawn: "Gegner-Spawn",
  traps_spawn: "Fallen-Spawn",
  min_spawn_interval_ms: "Min. Spawn-Intervall (ms)",
  max_spawn_interval_ms: "Max. Spawn-Intervall (ms)",
  same_lane_chance: "Chance gleiche Spur",
  probability_of_spawn_in_player_lane:
    "Wahrscheinlichkeit Spawn in Spieler-Spur",
  collision_tolerance_px: "Kollisions-Toleranz (px)",
  scoring_rules: "Punkte-Regeln",
  hit_penalty: "Treffer-Strafe",
  powerup_reward: "Power-up-Belohnung",
  score_speed_divider: "Punkte-Geschwindigkeits-Teiler",
  reset_combo_on_hit: "Combo bei Treffer zurücksetzen",
  camera_settings: "Kamera-Einstellungen",
  normal_zoom: "Normaler Zoom",
  hit_zoom: "Zoom bei Treffer",
  zoom_lerp_speed: "Zoom-Übergangsgeschwindigkeit",
  game_end_conditions: "Spielende-Bedingungen",
  phone_dialog_score_threshold: "Punkte-Schwelle für Telefon-Dialog",

  // 8. Farben-Tab (TabColors)
  background_gradient: "Hintergrund-Verlauf",
  first_color: "Erste Farbe",
  second_color: "Zweite Farbe",
  particle_hit_color: "Treffer-Partikel-Farbe",
  particle_powerup_color: "Power-up-Partikel-Farbe",
  main_background_color: "Haupt-Hintergrundfarbe",
  ground_color: "Bodenfarbe",
  hud_colors: "HUD-Farben",
  hud_background: "HUD-Hintergrund",
  score_text_color: "Punkte-Textfarbe",
  level_text_color: "Level-Textfarbe",
  combo_text_color: "Combo-Textfarbe",
  overlay_colors: "Overlay-Farben",
  backdrop_color: "Hintergrund-Farbe",
  card_background: "Karten-Hintergrund",
  card_border_color: "Karten-Rahmenfarbe",
  explosion_particle_color: "Explosions-Partikel-Farbe",

  // 9. QR-Vorschau-Komponente (previewerQr)
  gif_tab: "GIF-Tab",
  game_tab: "Spiel-Tab",
  welcome_gif_upload: "Willkommens-GIF hochladen",
  default_welcome: "Standard-Willkommen",
  loading_animation: "Ladeanimation",
  hide_previewer: "Vorschau ausblenden",
  show_previewer: "Vorschau anzeigen",
  edit_game_settings: "Spieleinstellungen bearbeiten",
  save_and_close: "Speichern und schließen",
  animation_scale: "Animations-Skalierung",
  animation_slide_x: "Horizontale Slide-Animation",
  animation_slide_y: "Vertikale Slide-Animation",
  animation_fade: "Fade-Animation",
  game_settings_saved: "Spieleinstellungen gespeichert",
  no_game_configured: "Kein Spiel konfiguriert",

  // 10. GIF-Auswahl (gifSelector)
  gallery_name: "Galerie-Name",
  change_gallery_name: "Galerie-Name ändern",
  add_gif: "GIF hinzufügen",
  select_gif: "GIF auswählen",
  show_gif: "GIF anzeigen",
  selected_gif: "Ausgewähltes GIF",
  count: "Anzahl",
  select_category: "Kategorie auswählen",
  after_typing_enter: "Nach Eingabe Enter drücken",
  search: "Suchen",
  no_gif_available: "Kein GIF verfügbar",
  to_use_ready_gifs_search_category_or_product:
    "Für fertige GIFs Kategorie oder Produkt suchen",
  max_file_size_2mb: "Maximale Dateigröße 2 MB",
  upload_file: "Datei hochladen",
  drag_and_drop_to_upload_or: "Ziehen und ablegen zum Hochladen oder",
  here: "hier",
  click: "klicken",
  all: "Alle",
  no_gif_found: "Kein GIF gefunden",
  for_adding_file_use_upload_center:
    "Zum Hinzufügen einer Datei Upload-Center verwenden",
  to_use_external_gif_link_fill_fields:
    "Für externen GIF-Link Felder ausfüllen",
  gif_url_hint: "Vollständige GIF-Datei-URL",
  gif_url: "GIF-URL",
  add: "Hinzufügen",
  title: "Titel",
  link: "Link",
  description: "Beschreibung",
  add_new_gallery: "Neue Galerie hinzufügen",
  enter_valid_link: "Gültigen Link eingeben",
  create_gif: "GIF erstellen",
  ready_gifs: "Fertige GIFs",
  gif_gallery: "GIF-Galerie",
  edit_gif: "GIF bearbeiten",
  max_background_gif_size_2mb: "Maximale Hintergrund-GIF-Größe 2 MB",
  uploaded_successfully: "Erfolgreich hochgeladen",
  gif_upload_error: "Fehler beim GIF-Upload",

  // 11. Zusätzliche Texte und Test-Keys
  preview: "Vorschau",
  start_button_text: "Start-Button-Text",
  game_over_text: "Game-Over-Text",
  game_over_subtext: "Game-Over-Untertext",
  mobile_prompt_text: "Mobil-Abfrage-Text",
  submit_button_text: "Absenden-Button-Text",
  optional: "Optional",
  game_background: "Spiel-Hintergrund",
  background_gradient_colors: "Hintergrund-Verlaufsfarben",
  frames_per_enemy: "Frames pro Gegner",
  frames_per_powerup: "Frames pro Power-up",
  win_threshold: "Sieg-Schwelle",
  score_to_win: "Punkte zum Gewinnen",
  your_work_page_name: "Persönlicher/Firmenkundlicher Kiwvar",
  "pdf_gallery": {
    "display_mode": "PDF-Galerie Anzeigemodus",
    "display_mode_label": "Anzeigemodus",
    "layout": {
      "list": "Listenansicht",
      "accordion": "Akkordeon-Ansicht",
      "slider": "Slider-Ansicht"
    },
    "gallery_name": "Galeriename",
    "selected_gallery": "Ausgewählte Galerie",
    "add_file": "Datei hinzufügen",
    "pdf_gallery_label": "PDF-Galerie",
    "select_file": "Datei auswählen",
    "title": "Titel",
    "pdf_url": "PDF-URL",
    "description": "Beschreibung",
    "add_button": "Hinzufügen",
    "all": "Alle",
    "image_gallery": "Bildergalerie",
    "edit_pdf": "PDF bearbeiten",
    "preview": "Vorschau",
    "add_pdf_gallery": "PDF-Galerie hinzufügen",
    "default_gallery_name": "Galerie",
    "gallery_prefix": "Galerie",
    "tabs": {
      "add_file": "Datei hinzufügen",
      "pdf_gallery": "PDF-Galerie",
      "link": "Link"
    },
    "messages": {
      "file_too_large": "Die Dateigröße darf 10 MB nicht überschreiten.",
      "invalid_file_type": "Bitte wählen Sie nur Dokument- und Textdateien aus.",
      "upload_error": "Fehler beim Hochladen der Datei.",
      "only_pdf_txt_allowed": "Es können nur PDF- und TXT-Dateien hinzugefügt werden.",
      "title_url_required": "Bitte geben Sie den Titel und die Datei-URL ein."
    }
  },
  "special_info_desc": {
    "textCards": "Fügen Sie Textkarten hinzu, um Benutzerinformationen wie Beschreibungen, Hintergrund oder eine kurze Biografie anzuzeigen.",
    "customerClubSettings": "Legen Sie die Nachricht für die Mitgliedschaft im Kundenclub fest, die nach der Registrierung an Benutzer gesendet wird.",
    "advanceSettings": "Verwalten Sie erweiterte und intelligente Einstellungen, um das Seitenverhalten anzupassen.",
    "voiceGallery": "Laden Sie Audiodateien hoch und verwalten Sie diese, um sie auf der Seite abzuspielen.",
    "VideoGallery": "Fügen Sie Videos zur Einführung, Schulung oder Inhaltsanzeige hinzu.",
    "imageUploader": "Laden Sie Bilder hoch, um sie in der Galerie oder in verschiedenen Teilen der Seite anzuzeigen.",
    "colorPallete": "Wählen Sie benutzerdefinierte Farben, um das Seitendesign zu personalisieren.",
    "socialMediaIcons": "Fügen Sie Social-Media-Links für einen schnellen Benutzerzugriff hinzu.",
    "pdfSelector": "Laden Sie PDF-Dateien hoch, damit Benutzer sie ansehen oder herunterladen können.",
    "FeedBack": "Erhalten Sie Benutzerkommentare und Feedback zu Diensten oder Inhalten.",
    "consultationNew": "Erstellen Sie ein Formular für Benutzer, um Anfragen einzureichen oder Kontakt aufzunehmen."
  },
  "voice_gallery": {
    "autoplay_warning": "Sie können jeweils nur eine Audiodatei für die automatische Wiedergabe festlegen.",
    "autoplay": "Automatische Wiedergabe"
  },
  "card": {
    "consultation": {
      "title": "Anfrageformular"
    },
    "form": {
      "name": "Vorname",
      "surname": "Nachname",
      "phone": "Handynummer",
      "email": "E-Mail",
      "address": "Adresse",
      "national_id": "National-ID",
      "location": "Standort",
      "description": "Beschreibung"
    },
    "feedback": {
      "title": "Ihr Feedback",
      "description": "Bitte helfen Sie uns, unsere Dienstleistungen zu verbessern, indem Sie die folgenden Fragen beantworten:",
      "q1": "Wie zufrieden sind Sie mit den QRLand-Diensten?",
      "q2": "Inwieweit haben die QRLand-Dienste Ihre Bedürfnisse abgedeckt?",
      "q3": "Wie angemessen war der Preis für den erhaltenen Service?",
      "q4": "Teilen Sie uns Ihre Gedanken mit, um unsere Dienstleistungen zu verbessern."
    },
    "pdf": {
      "gallery_name": "QRLand Vorschlagsgalerie",
      "item1_title": "Vorschlag zur Produkteinführung",
      "item1_desc": "Umfassende Einführung in die QRLand-Dienste, wie intelligente QR-Codes funktionieren und Vorteile für Unternehmen.",
      "item2_title": "Vorschlag für digitale Visitenkarten",
      "item2_desc": "Einführung in die digitale Visitenkarte von QRLand, schnelles Teilen von Kontaktinformationen und soziales CRM."
    },
    "pdf_selector": {
      "title": "PDF-Galerie",
      "description": "Beschreibung"
    },
    "info": {
      "visit_name": "QRLand / Digitale Visitenkarte",
      "organization_name": "QRLand",
      "sub_organ": "Die erste dynamische QR-Generator-Plattform",
      "user_name": "Digitale Visitenkarte",
      "fax": "Fax: 02191016066",
      "location_desc": "Nr. 6, Khandan-Gasse, nach der Seyed Khandan-Brücke, Shariati-Str., Teheran",
      "postal_code": "Postleitzahl: 1541946815",
      "about_us": "Aufgrund der Probleme mit physischen Visitenkarten hat QRLand das Produkt 'Digitale Visitenkarte' eingeführt, das physische Einschränkungen beseitigt und Bäume rettet.",
      "full_address": "Iran, Provinz Teheran, Teheran, Bezirk 3, Seyed Khandan, Dr. Ali Shariati, Khandan"
    },
    "extra": {
      "field1": "🟥 Erstellen Sie eine ähnliche digitale Visitenkarte für Ihr Unternehmen.\n🟧 Testen Sie es 3 Tage lang kostenlos.\n🟨 Klicken Sie hier, um sich kostenlos zu registrieren.",
      "field2": "Ihre digitale Visitenkarte verfügt über einen dynamischen QR-Code. Sie können Informationen jederzeit über Ihr Mobiltelefon bearbeiten. Der Code ändert sich nie.",
      "field3": "💲 Die Kosten für diese Visitenkarte betragen 900.000 Toman."
    },
    "gallery": {
      "name": "Wir werden immer an Ihrer Seite stehen..."
    },
    "social": {
      "address_hint": "Bitte geben Sie Ihre Adresse ein",
      "address_label": "Adresse",
      "instagram_hint": "Bitte geben Sie Ihre Instagram-URL ein",
      "instagram_label": "Instagram",
      "whatsapp_hint": "Bitte geben Sie Ihre WhatsApp-URL ein",
      "whatsapp_label": "WhatsApp"
    },
    "video": {
      "item1_name": "Warum QRLand Visitenkarte? Was macht QRLand anders?",
      "item1_title": "Warum QRLand Visitenkarte",
      "item2_name": "Einführung in die digitale Visitenkarte von QRLand",
      "item2_title": "Die beste Alternative zu physischen Visitenkarten"
    },
    "club": {
      "title": "Kundenclub-Mitgliedschaft",
      "description": "Dies ist kein gewöhnlicher Kundenclub!\nRegistrieren Sie Ihre Nummer"
    },
    "audio": {
      "category_all": "Alle",
      "item1_title": "Umfassender Leitfaden für digitale Visitenkarten",
      "diff_seconds": "vor 1 Sekunde"
    }
  },
  "pic": {
    "background_image": "Hintergrundbild",
    "image_display_type": "Bildanzeigetyp",
    "image_orientation": "Bildausrichtung:",
    "horizontal": "Horizontal",
    "vertical": "Vertikal",
    "change_display_mode": "Anzeigemodus ändern",
    "image": "Bild",
    "uploaded_image": "Hochgeladenes Bild"
  },
  "send_limit_per_user": "Sendelimit pro Benutzer (0 = unbegrenzt)",
    "enable_discount_code": "Rabattcode aktivieren",
    "add_new_discount_code": "Neuen Rabattcode hinzufügen",
    "no_discount_codes_added": "Keine Rabattcodes hinzugefügt",
"toolsManagment": "Verwaltungswerkzeuge",
"gateway": {
  "edit": "Bearbeiten",
  "integrated_edit_all_sections": "Integrierte Bearbeitung aller Abschnitte",
  "show_descriptions": "Beschreibungen anzeigen",
  "search_section_placeholder": "Abschnitt suchen...",
  "no_section_found": "Kein Abschnitt mit diesem Namen gefunden.",
  "back_to_menu": "Zurück zum Menü",
  "cancel": "Abbrechen",
  "save": "Speichern"
},
"gridShow": "Rasteransicht",
"tableShow": "Tabellenansicht",
"editvisit": {
  special_info_single: {
    text_cards_description:
      "Fügen Sie Textkarten hinzu, um Benutzerinformationen wie Beschreibungen, Erfahrungen oder eine kurze Vorstellung anzuzeigen.",

    customer_club_settings_description:
      "Legen Sie die Nachricht für die Mitgliedschaft im Kundenclub fest, die nach der Registrierung der Telefonnummer an Benutzer gesendet wird.",

    advance_settings_description:
      "Verwalten Sie erweiterte und intelligente Einstellungen, um das Verhalten und die Funktionen der Seite individuell anzupassen.",

    voice_gallery_description:
      "Audiodateien hochladen und verwalten, die auf der Seite abgespielt werden können.",

    video_gallery_description:
      "Videos zur Vorstellung, Schulung oder Darstellung von Inhalten hinzufügen und anzeigen.",

    image_uploader_description:
      "Bilder für die Anzeige in der Galerie oder in verschiedenen Bereichen der Seite hochladen.",

    color_palette_description:
      "Wählen Sie individuelle Farben zur Anpassung des Erscheinungsbilds und Designs der Seite.",

    social_media_icons_description:
      "Fügen Sie Links zu sozialen Netzwerken für einen schnellen Zugriff hinzu.",
  },
},

"editBpage": {
  special_info_single: {
    banner_selector_description:
      "Laden Sie das Hauptbanner des Einkaufszentrums hoch oder ändern Sie es.",

    logo_select_description:
      "Legen Sie das Logo des Unternehmens oder Einkaufszentrums fest.",

    service_description:
      "Verwalten Sie die wichtigsten Dienstleistungen und Einrichtungen des Einkaufszentrums.",

    faq_description:
      "Häufig gestellte Fragen von Kunden hinzufügen und bearbeiten.",

    blog_description:
      "Artikel und Neuigkeiten über das Einkaufszentrum hinzufügen.",

    floor_description:
      "Etagen und Geschäftseinheiten des Einkaufszentrums verwalten.",

    text_cards_description:
      "Beschreibung und benutzerbezogene Informationen eingeben.",

    social_media_icons_description:
      "Links zu sozialen Netzwerken für die Kundenkommunikation hinzufügen.",

    pic_selector_description:
      "Bilder des Einkaufszentrums und der Geschäfte hinzufügen.",

    video_gallery_description:
      "Vorstellungs- oder Werbevideos hochladen.",

    pdf_selector_description:
      "Kataloge und textbasierte Informationsdateien verwalten.",

    feedback_description:
      "Bereich für Meinungen und Feedback von Besuchern verwalten.",

    consultation_new_description:
      "Formular zur Erfassung von Kundeninformationen oder Anfragen verwalten.",

    service_section_description:
      "Individuelle Servicebereiche erstellen.",

    counter_service_description:
      "Statistiken und Erfolge des Einkaufszentrums numerisch anzeigen.",

    counter_description:
      "Countdown für Veranstaltungen oder Eröffnungen einstellen.",

    personnel_description:
      "Manager und wichtige Teammitglieder vorstellen.",

    customer_club_settings_description:
      "SMS- und Registrierungseinstellungen für den Kundenclub verwalten.",

    work_sheet_description:
      "Arbeitszeiten und Betriebstage des Einkaufszentrums festlegen.",

    pallet_commercial_description:
      "Farben und visuellen Stil der Seite festlegen.",

    default_description:
      "Bereich {title} auf der Geschäftsseite hinzufügen und verwalten.",
  },
},

store_special_info_single: {
  shop_login_config_description:
    "Einstellungen der Anmeldeseite und Änderung des Shop-Logos.",

  banner_selector_description:
    "Shop-Banner hochladen und verwalten.",

  text_cards_description:
    "Textinformationen, Vorstellung und Über uns.",

  product_description:
    "Produkte erstellen, verwalten und bearbeiten.",

  special_category_manager_description:
    "Kategorien für Sonderangebote und reduzierte Produkte verwalten.",

  social_media_icons_description:
    "Links zu sozialen Netzwerken des Shops hinzufügen.",

  blog_description:
    "Blogbeiträge schreiben und verwalten.",

  service_description:
    "Zusätzliche angebotene Dienstleistungen vorstellen.",

  faq_description:
    "Liste der häufig gestellten Fragen verwalten und anzeigen.",

  pic_selector_description:
    "Bildergalerie des Shops hochladen und verwalten.",

  video_gallery_description:
    "Vorstellungs- und Werbevideos hochladen.",

  pdf_selector_description:
    "Anleitungen oder PDF-Kataloge bereitstellen.",

  feedback_description:
    "Kundenmeinungen und Feedback verwalten.",

  counter_description:
    "Countdown für Veranstaltungen oder Angebote einstellen.",

  consultation_description:
    "Formular für Anfragen oder Beratungswünsche erstellen.",

  service_section_description:
    "Individuelle Servicebereiche verwalten.",

  counter_service_description:
    "Statistiken, Zahlen und Erfolge des Shops anzeigen.",

  personnel_description:
    "Teammitglieder und Shop-Mitarbeiter vorstellen.",

  work_sheet_description:
    "Öffnungstage und Arbeitszeiten des Shops festlegen.",

  default_description:
    "Bereich {title} auf der Shop-Seite hinzufügen und verwalten.",
},
edit_gold_special_info_single: {
  product_info_title: "Produktinformationen",
  product_info_description:
    "Grundlegende Produktdaten, Eigenschaften, Preis und zusätzliche Beschreibungen erfassen und bearbeiten.",

  asset_management_title: "Asset-Verwaltung",
  asset_management_description:
    "Assets verwalten, Werte zuweisen und die mit dem Produkt verbundenen Wallet-Informationen verwalten.",

  add_social_networks_title: "Soziale Netzwerke hinzufügen",
  social_networks_title: "Soziale Netzwerke",
  social_media_description:
    "Fügen Sie Links zu sozialen Netzwerken hinzu, damit Kunden schneller mit Ihrer Marke in Kontakt treten können.",

  add_video_title: "Video hinzufügen",
  video_description:
    "Fügen Sie Präsentations-, Schulungs- oder Werbevideos für das Produkt hinzu und zeigen Sie diese an.",

  add_image_title: "Bild hinzufügen",
  image_description:
    "Laden Sie hochwertige Produktbilder aus verschiedenen Perspektiven hoch, um das Produkt in der Galerie besser darzustellen.",

  select_color_title: "Farbe auswählen",
  color_palette_description:
    "Passen Sie die Farbkombination und das Erscheinungsbild der Produktseite an Ihre Markenidentität an.",
},

edit_multicard_special_info_single: {
  add_account_description:
    "Name, Profilbild und Hintergrund bearbeiten",

  management_account_description:
    "Bankkontoinformationen hinzufügen und bearbeiten",

  management_color_description:
    "Farben der Schaltflächen und des Hintergrunds ändern",
},

edit_feedback_special_single: {
  base_info_description:
    "Grundinformationen und Formulartitel bearbeiten",

  image_uploader_description:
    "Logo des Feedbackformulars hochladen und verwalten",

  feedback_description:
    "Feldeinstellungen und Verwaltung des Feedbackformulars",

  color_palette_description:
    "Farbschema auswählen und Erscheinungsbild des Formulars anpassen",
},

edit_gitf_special_info_single: {
  default_description:
    "Bereich {title} im QR-Rahmen der Erinnerungen hinzufügen und verwalten.",
},

edit_catalog_special_info_single: {
  text_cards_description:
    "Grundinformationen, Titel und Beschreibung des Katalogs",

  image_uploader_description:
    "Logo oder Hauptbild hochladen und verwalten",

  pic_selector_description:
    "Katalog- oder Broschürenseiten hochladen und verwalten",

  social_media_icons_description:
    "Links zu sozialen Netzwerken hinzufügen und verwalten",

  color_palette_description:
    "Farbschema auswählen und Erscheinungsbild anpassen",
},

edit_menu_special_info_single: {
  theme_selector_description:
    "Vorlage auswählen, um eine andere Kategorisierung anzuwenden",

  login_config_description:
    "Einstellungen und Erscheinungsbild der Anmeldeseite",

  general_settings_description:
    "Allgemeine Einstellungen für Währung und Geschäftsart.",

  banner_selector_description:
    "Bannerbild hochladen und auswählen, das oben auf der Seite angezeigt wird und das Erscheinungsbild des Menüs oder Profils attraktiver macht.",

  product_description:
    "Produkte oder Dienstleistungen mit Details wie Bild, Preis und individueller Beschreibung erstellen und verwalten.",

  text_cards_description:
    "Textkarten hinzufügen, um grundlegende Benutzerinformationen wie allgemeine Beschreibungen, Erfahrungen oder eine kurze Vorstellung anzuzeigen.",

  social_media_description:
    "Links und Symbole für soziale Netzwerke hinzufügen, um eine schnellere Kommunikation und einen einfacheren Kundenzugriff zu ermöglichen.",

  photo_gallery_description:
    "Eine Bildergalerie erstellen, um Produktfotos, Arbeitsproben oder die Geschäftsumgebung zu präsentieren.",

  video_gallery_description:
    "Eine Videogalerie hinzufügen, um Werbeclips, Schulungsvideos oder Präsentationen anzuzeigen.",

  feedback_description:
    "Einen Bereich zur Anzeige von Kundenmeinungen, Feedback und Kundenzufriedenheit erstellen.",

  working_hours_description:
    "Arbeitszeiten und Geschäftszeiten festlegen.",
},

edit_pdf_special_info_single: {
  base_info_title: "Informationen",
  base_info_description:
    "Textkarten hinzufügen, um grundlegende Benutzerinformationen wie allgemeine Beschreibungen, Erfahrungen oder eine kurze Vorstellung anzuzeigen.",

  image_uploader_title: "Logo hochladen",
  image_uploader_description:
    "Ein Bild als Logo oder Profilbild hochladen und auswählen, das auf der Seite angezeigt wird.",

  pdf_selector_title: "PDF-Galerie hinzufügen",
  pdf_selector_description:
    "Eine Galerie aus PDF- oder Textdateien erstellen, mit der Möglichkeit, ein Titelbild und eine individuelle Beschreibung für jede Datei hinzuzufügen.",

  social_media_icons_title: "Soziale Netzwerke hinzufügen",
  social_media_icons_description:
    "Links und Symbole für soziale Netzwerke hinzufügen, um eine schnellere Kommunikation und einen einfacheren Zugriff zu ermöglichen.",

  color_palette_title: "Farbe auswählen",
  color_palette_description:
    "Eine Vorlagenfarbe auswählen und das Erscheinungsbild der Elemente an Ihre Marke anpassen.",
},

edi_photogallery_spcial_info_single: {
  default_description:
    "Bereich {title} in der Fotogalerie hinzufügen und verwalten.",
},

edi_social_special_info_single: {
  banner_selector_title: "Foto hochladen",
  banner_selector_description:
    "Hintergrundbild oder Banner am oberen Rand Ihrer Social-Media-Seite auswählen und hochladen.",

  base_info_title: "Informationen",
  base_info_description:
    "Grundinformationen wie Haupttitel und Profilbeschreibung eingeben.",

  image_uploader_title: "Logo hochladen",
  image_uploader_description:
    "Ihr persönliches oder Markenlogo bzw. Profilbild für die Anzeige auf der Seite hochladen.",

  social_media_icons_title: "Soziale Netzwerke hinzufügen",
  social_media_icons_description:
    "Links zu sozialen Netzwerken wie Instagram, Telegram, WhatsApp, LinkedIn und anderen hinzufügen, damit deren Symbole auf der Seite angezeigt werden.",
},

edit_text_special_info_single: {
  base_info_title: "QR-Informationen und Texte",
  base_info_subtitle: "Haupttext und Textfelder",
  base_info_description:
    "Titel, Haupttext über uns und benutzerdefinierte QR-Textfelder bearbeiten",

  image_uploader_title: "Logo und Hintergrundbild",
  image_uploader_subtitle: "Bildeinstellungen",
  image_uploader_description:
    "Individuelles Logo oder Kartenhintergrund hochladen und ändern",

  color_palette_subtitle: "Erscheinungsbild anpassen",
  color_palette_description:
    "Kopfzeilen-, Hintergrund- und Textfarben anpassen, um Lesbarkeit und Kontrast zu verbessern",
},

edit_video_special_info_single: {
  base_info_title: "Informationen",
  base_info_description:
    "Grundlegende Informationen wie Titel und QR-Code-Adresse bearbeiten.",

  image_uploader_title: "Logo hochladen",
  image_uploader_description:
    "Logo der Seite hochladen und verwalten.",

  video_gallery_title: "Videogalerie",
  video_gallery_description:
    "Videos zur Anzeige in der Galerie hinzufügen, bearbeiten und verwalten.",

  social_media_icons_title: "Soziale Netzwerke hinzufügen",
  social_media_icons_description:
    "Links zu sozialen Netzwerken und Kontaktmöglichkeiten hinzufügen.",

  color_palette_title: "Farbe auswählen",
  color_palette_description:
    "Farbschema ändern und ein passendes Farbthema für die Seite auswählen.",
},

edit_product_special_info_single: {
  factory_info_description:
    "Informationen und Vorstellung des Unternehmens bearbeiten",

  single_product_editor_description:
    "Grundinformationen und Aktionsschaltflächen wie „Kaufen“ bearbeiten",

  customer_club_settings_description:
    "Kundenclub-Einstellungen und SMS-Versand",

  advance_settings_description:
    "Erweiterte Anzeige- und Sicherheitseinstellungen",

  features_description:
    "Produkteigenschaften und technische Spezifikationen verwalten",

  voice_gallery_description:
    "Podcasts und Audiodateien hochladen und verwalten",

  image_uploader_description:
    "Produktbildergalerie hochladen und verwalten",

  video_gallery_description:
    "Galerie mit zugehörigen Produktvideos hinzufügen und verwalten",

  social_media_icons_description:
    "Links zu sozialen Netzwerken hinzufügen und verwalten",

  color_palette_description:
    "Farbthema auswählen und Vorlage anpassen",
},

edit_product_pro_special_info_single: {
  factory_info_description:
    "Allgemeine Informationen und Vorstellung des Produktionsunternehmens eingeben.",

  single_product_editor_description:
    "Grundinformationen, Vertrauenssiegel und Kaufschaltfläche des Produkts festlegen.",

  customer_club_settings_description:
    "SMS-Einstellungen und Kundenmitgliedschaft im Club.",

  features_description:
    "Produkteigenschaften und technische Spezifikationen hinzufügen.",

  feedback_description:
    "Bereich für Bewertungen und Feedback von Käufern.",

  consultation_description:
    "Formular für Beratungsanfragen oder Bestellungen.",

  advance_settings_description:
    "Erweiterte und intelligente Einstellungen für die Produktanzeige.",

  voice_gallery_description:
    "Audiodateien zur Produktvorstellung oder Produktanleitung.",

  image_uploader_description:
    "Verschiedene Produktbilder hochladen.",

  video_gallery_description:
    "Zugehörige Präsentations- oder Schulungsvideos.",

  social_media_icons_description:
    "Links zu sozialen Netzwerken für weitere Kommunikation.",

  color_palette_description:
    "Farben und visuellen Stil der Produktseite festlegen.",
},

edit_voice_special_info_single: {
  base_info_voice_description:
    "Grundinformationen und Spezifikationen der Audiogalerie",

  image_uploader_description:
    "Logo oder Titelbild hochladen und verwalten",

  voice_gallery_description:
    "Audiodateien und Podcasts hochladen und verwalten",

  color_palette_description:
    "Farbschema auswählen und Erscheinungsbild der Galerie anpassen",
},

edit_voice_pro_special_info_single: {
  base_info_description:
    "Titel und Beschreibung der Galerie bearbeiten",

  image_uploader_description:
    "Logo und Hauptcover hochladen und verwalten",

  voice_gallery_acc_description:
    "Audiodateien hochladen, löschen und verwalten",

  social_media_icons_description:
    "Links zu sozialen Netzwerken hinzufügen und verwalten",

  color_palette_description:
    "Farbschema auswählen und Erscheinungsbild der Galerie anpassen",
},
edit_bpage_special_info_special: {
  advertising_sites: "Werbeplattformen",
stores: "Shops",

divar: "Divar",
divar_hint: "Divar-Link eingeben",

sheypoor: "Sheypoor",
sheypoor_hint: "Sheypoor-Link eingeben",

digikala: "Digikala",
digikala_hint: "Digikala-Link eingeben",

basalam: "Basalam",
basalam_hint: "Basalam-Link eingeben",

snappshop: "SnappShop",
snappshop_hint: "SnappShop-Link eingeben",

technolife: "Technolife",
technolife_hint: "Technolife-Link eingeben",

torob: "Torob",
torob_hint: "Torob-Link eingeben",

emalls: "eMalls",
emalls_hint: "eMalls-Link eingeben",

cafebazaar: "Cafe Bazaar",
cafebazaar_hint: "Cafe-Bazaar-Link eingeben",

googleplay: "Google Play",
googleplay_hint: "Google-Play-Link eingeben",

samsung: "Samsung",
samsung_hint: "Galaxy-Store-Link eingeben",

apple: "Apple",
apple_hint: "App-Store-Link eingeben",
  add_audio_gallery: "Audiogalerie hinzufügen",
  factory_information: "Informationen zum Unternehmen",
  trust_badge: "Vertrauenssiegel",
  buy_button: "Kaufen-Schaltfläche",
  smart_settings: "Intelligente Einstellungen",
  add_product_feature: "Produkteigenschaft hinzufügen",
  product_features: "Produkteigenschaften",
  add_audio_file: "Audiodatei hinzufügen",
  audio_gallery: "Audiogalerie",
  text: "Text",
  logo_background: "Logo / Hintergrund",
  select_color: "Farbe auswählen",
  information: "Informationen",
  luck_management: "Glücksverwaltung",
  registration_management: "Anmeldungsverwaltung",
  turning: "Blättern",
  slider: "Slider",
  vertical: "Vertikal",
  upload_catalog_brochure_images: "Katalog- / Broschürenbilder hochladen",
  upload_banner: "Banner hochladen",
  upload_header_image: "Headerbild hochladen",
  upload_image: "Bild hochladen",
  services: "Dienstleistungen",
  faq: "Häufig gestellte Fragen",
  blog: "Blog",
  create_product: "Produkt erstellen",
  user_information: "Benutzerinformationen",
  add_social_media: "Social-Media hinzufügen",
  photo_gallery: "Fotogalerie",
  video_gallery: "Videogalerie",
  pdf_gallery: "PDF-Galerie",
  feedback: "Feedback",
  request_form: "Anfrageformular",
  create_section: "Abschnitt erstellen",
  achievements: "Erfolge",
  countdown: "Countdown",
  team_members: "Teammitglieder",
  working_hours: "Arbeitszeiten",
  upload_logo: "Logo hochladen",
  create_store: "Shop erstellen",
  customer_club_membership_sms: "SMS zur Mitgliedschaft im Kundenclub",
  product_information: "Produktinformationen",
  asset_management: "Asset-Verwaltung",
  social_media: "Social Media",
  add_video: "Video hinzufügen",
  add_image: "Bild hinzufügen",
  add_user_information: "Benutzerinformationen hinzufügen",
  manage_accounts: "Konten verwalten",
  manage_color: "Farben verwalten",
  download_qr: "QR-Code herunterladen",
  add_store: "Shop hinzufügen",
  manage_appointments: "Termine verwalten",
},
edit_gift_special_info_special: {
  gift_story: "Geschenkgeschichte",
  profile_image: "Profilbild",
  featured_images: "Ausgewählte Bilder",
  image_gallery: "Bildergalerie",
  video_gallery: "Videogalerie",
  add_audio_file: "Audiodatei hinzufügen",
  select_color: "Farbe auswählen",
},edit_insurance_special_info_special: {
  login_settings: "Anmeldeeinstellungen",
  shop_logo_images: "Shop-Logo und Bilder",
  login_page_information: "Informationen zur Anmeldeseite",
  upload_banner_logo: "Banner und Logo hochladen",
  user_information: "Benutzerinformationen",
  manage_products_insurance: "Produkte / Versicherungen verwalten",
  special_sale: "Sonderangebote",
  add_social_media: "Social Media hinzufügen",
  blog: "Blog",
  services: "Dienstleistungen",
  faq: "Häufig gestellte Fragen",
  photo_gallery: "Fotogalerie",
  video_gallery: "Videogalerie",
  pdf_gallery: "PDF-Galerie",
  feedback: "Feedback",
  countdown: "Countdown",
  request_form: "Anfrageformular",
  create_section: "Abschnitt erstellen",
  achievements: "Erfolge",
  team_members: "Teammitglieder",
  working_hours: "Arbeitszeiten",
  shop_login_description: "Einstellungen für Shop-Logo und Anmeldeseite",
  insurance_manage_description: "Produkt- / Dienstleistungsliste hinzufügen und bearbeiten",
  banner_description: "Headerbilder verwalten",
},
};
